import { LOCALES } from '../../constants';

const PORTUGUESE = {
  [LOCALES.PORTUGUESE]: {
    //GLOBAL
    currencyFormat: 'BRL',
    totalSales: 'Total de vendas',
    totalPercentageProfit: 'Total percentual beneficio',
    totalValueProfit: 'Total valor beneficio',
    totalPositivation: 'Total positivação',
    totalPositivationMix: 'Total positivação mix',
    title: 'Título',
    message: 'Mensagem',
    description: 'Descrição',
    dateCreation: 'Dt.criação',
    view: 'Visualizar',
    //TESTE
    dashboard: 'Dashboard',
    telemetria: 'Telemetria',
    recommendations: 'Recomendações',
    unavailableRecommendations: 'Não foi possível carregar recomendações. Sua compra segue normalmente.',
    positivationSellers: 'Positivação por vendedor',
    efficiencySalesPotential: 'Eficiência do potencial de vendas',
    //WEEKDAY
    weekDayMonday: 'SEG',
    weekDayTuesday: 'TER',
    weekDayWednesday: 'QUA',
    weekDayThursday: 'QUI',
    weekDayFriday: 'SEX',
    weekDaySaturday: 'SÁB',
    weekDaySunday: 'DOM',
    //COMMON
    commonTableFilterLabel: 'Filtros',
    commonTableHeaderLabelActions: 'Ações',
    commonTablePaginationLabelRowsPerPage: 'Linhas por página',
    commonAppbarMenuProfile: 'Perfil do usuário',
    commonAppbarMenuLogout: 'Sair',
    commonInputSearch: 'Pesquisar ...',
    commonLoadingMessage: 'Carregando...',
    commonCancelingMessage: 'Cancelando...',
    commonSavingMessage: 'Salvando...',
    commonSendMessage: 'Enviando...',
    commonWaitingMessage: 'Aguarde...',
    commonSendButtonMessage: 'Enviar',
    commonErrorMessage: 'Ocorreu um erro na sua solicitação',
    commonAutocompleteSelectPlaceholder: 'Selecionar...',
    commonButtonAddImage: 'Adicionar',
    commonButtonRemoverImage: 'Remover',
    commonButtonReturn: 'Retornar',
    commonButtonClose: 'Fechar',
    commonLabelDelete: 'Deletar',
    commonLabelResend: 'Reenviar',
    commonLabelEdit: 'Editar',
    commonLabelMinimize: 'Minimizar',
    commonLabelStatus: 'Status',
    commonLabelCancel: 'Cancelar',
    commonLabelSelect: 'Selecionar',
    commonLabelFilter: 'Aplicar filtros',
    commonLabelUserRole: 'Nivel usuário',
    commonLabelActive: 'Ativo ?',
    commonLabelConfirm: 'Confirmar',
    commonLabelCheckAll: 'Marcar todos',
    commonLabelUncheckAll: 'Desmarcar todos',
    commonLabelSelectFile: 'Selecionar arquivos',
    commonLabelDropFile: ' Solte os arquivos aqui ou clique em',
    commonLabelFind: 'Procurar',
    commonLabelClear: 'Limpar',
    commonLabelNotFound: 'Nenhuma informação encontrada',
    commonLabelWarning: 'Atenção',
    commonLabelOK: 'OK',
    commonLabelSave: 'Salvar',
    commonLabelExclude: 'Exclusão',
    commonLabelExcludeItem: 'Deseja excluir este item?',
    commonLabelExcludeSuccess: 'Excluído com sucesso',
    commonLabeTitleSellersFilter: 'Filtro de vendedores',
    commonLabelYes: 'Sim',
    commonLabelNo: 'Não',
    commonAutocompleteSelectNoOptions: 'Não encontrado',
    commonAutocompleteSelectNoOptionsName: 'Nome não encontrado',
    commonAutocompleteSelectLoading: 'Carregando...',
    commonButtonPrint: 'Imprimir',
    commonButtonDownloadExcel: 'Baixar Excel',
    commonFilterPaymentOptions: 'Forma de pagamento',
    commonNotInfo: 'Não Informado',
    //ROUTES-NOTIFICATION
    routesNotificationError401: 'Sem permissão para acessar a página',
    //USER ROLE
    userRoleVendor: 'Vendedor',
    userRoleSupervisor: 'Supervisor',
    userRoleManager: 'Gerente',
    userRoleDirector: 'Diretor',
    userRoleTech: 'Tecnologia',
    userRoleTelemarketing: 'Telemarketing',
    userRoleMaintenance: 'Manutenção',
    //SIDEBAR
    sidebarMenuItemDashboard: 'Dashboard',
    sidebarMenuItemDashboardAnalytics: 'Analítico',
    sidebarMenuItemDashboardClientVisit: 'Visita aos clientes',
    sidebarMenuItemDashboardIndicators: 'Indicadores',
    sidebarMenuItemDashboardTelemetria: 'Telemetria',

    sidebarMenuItemDashboardRecommendations: 'Recomendações',
    sidebarMenuItemDashboardPositivationSellers: 'Positivação por vendedor',
    sidebarMenuItemDashboardEfficiencySalesPotential: 'Eficiência do potencial de vendas',
    sidebarMenuItemEngine: 'Motor de vendas',
    sidebarMenuItemRewards: 'Recompensas',
    sidebarMenuItemTrading: 'Motor de Negociação',
    sidebarMenuItemSponsored: 'Patrocinados',
    sidebarMenuItemAccess: 'Acesso',
    sidebarMenuItemAccessProfile: 'Perfis de acesso',
    sidebarMenuItemUser: 'Usuários',
    sidebarMenuItemUserGroup: 'Times',
    sidebarMenuItemNotification: 'Notificações',
    sidebarMenuItemOrder: 'Meus Pedidos',
    sidebarMenuItemLoadControl: 'Controle de carga',
    sidebarMenuItemConfiguration: 'Configurações',
    sidebarMenuItemConfigurationApp: 'Configurações da Aplicação',
    sidebarMenuItemConfigurationInfrastructure: 'Configurações de Infraestrutura',
    sidebarMenuItemAudits: 'Auditorias',
    sidebarMenuItemAuditsUser: 'Usuários',
    sidebarMenuItemPromotion: 'Promoções ',
    sidebarMenuItemRegister: 'Cadastros',
    sidebarMenuItemLoadType: 'Tipos de carga',
    sidebarMenuItemReason: 'Motivos',
    sidebarMenuItemOrderType: 'Tipos de pedido',
    sidebarMenuItemOrderSplit: 'Divisão de pedidos',
    sidebarMenuItemClient: 'Clientes',
    sidebarMenuItemProductPhotos: 'Fotos dos produtos',
    sidebarMenuItemClientChecklist: 'Questionários de Clientes',
    sidebarMenuItemClientRatings: 'Avaliações',
    sidebarMenuItemClientVisit: 'Visita aos Clientes',
    sidebarMenuItemClientChecklistReport: 'Questionários',
    sidebarMenuItemJustifications: 'Justificativas',
    sidebarMenuItemProductBonification: 'Controle de produtos bonificados',
    sidebarMenuItemPromotionsKits: 'Promoção Kit/Combos',
    sidebarMenuItemFocusSupplier: 'Fornecedor Foco',
    sidebarMenuItemDailyRoute: 'Rota Diária',
    sidebarMenuItemDailyRouteReport: 'Relatório de Rota Diária',
    sidebarMenuItemRoutingPlanning: 'Roteirização - Planejamento',
    sidebarMenuItemRoutingReport: 'Roteirização - Relatório',
    sidebarMenuItemProductTechnicalData: 'Dados Técnicos',
    sidebarMenuItemClientVisityAndSalesReport: 'Visitas e Vendas de Clientes',
    sidebarMenuItemClientPositionReport: 'Posição Geral ',
    sidebarMenuItemRoutedClientsReport: 'Acompanhamento das Rotas dos Vendedores',
    sidebarMenuItemVendorRoute: 'Roteirização',
    sidebarMenuItemComissionReport: 'Comissão por liquidez',
    sidebarMenuItemMandatoryMix: 'Mix Obrigatório',
    //ERROR-404
    error404Title: 'Página não encontrada',
    error404Description: 'A página que você está procurando não existe ou foi removida.',
    error404Button: 'Retornar a ISA',
    //LOGIN
    loginTitle: 'Login',
    loginInputPassword: 'Senha',
    loginInputUsername: 'Login',
    loginLabelRememberMe: 'Lebrar-me nesse dispositivo',
    loginLabelResetPassword: 'Esqueci minha senha',
    loginButtonSubmit: 'Entrar',
    loginLabelTitle: 'Acessar',
    loginLabelSubtitle: 'Insira seus dados abaixo',
    loginLabelDevelopment: 'Desenvolvido por',
    loginLabelVersion: 'Versão',
    loginMessageError: 'Usuário ou senha inválidos!',
    loginMesageLoading: 'Autenticando, aguarde...',
    loginMessageSuccess: 'Login feito com sucesso!',
    //RESET-PASSWORD
    resetPasswordTitle: 'Esqueci minha senha',
    resetPasswordInputEmail: 'E-mail',
    resetPasswordLabelTitle: ' Esqueceu sua senha?',
    resetPasswordButtonSubmit: 'Enviar solicitação',
    resetPasswordButtonBack: 'Voltar',
    resetPasswordLabelSubtitle:
      'Por favor, insira o endereço de e-mail associado à sua conta e nós enviaremos um e-mail para redefinir sua senha.',
    resetPasswordSuccessTitle: 'Email enviado com sucesso',
    resetPasswordSuccessSubtitle: ' Enviamos um e-mail de confirmação para {email}. Por favor, verifique seu e-mail. ',
    resetPasswordLabelDevelopment: 'Desenvolvido por',
    resetPasswordLabelVersion: 'Versão',
    resetPasswordMessageError: 'Digite um e-mail válido!',
    //DROP-ZONE
    dropZoneValidationMaxSize: 'Limite de {sizeLimit} excedido.',
    dropZoneValidationMaxSizeByFile:
      'O arquivo excede o máximo permitido. Máximo permitido: {sizeLimit} (Arquivo desconsiderado)',

    //DASHBOARD - CLIENT VISIT
    dashboardClientVisitTitle: 'Dashboard - Visita aos clientes',
    dashboardClientVisitLocationDenied: 'Ative a localização do seu dispositivo!',
    dashboardClientVisitLocationError: 'Não foi possível obter sua localização atual.',
    dashboardClientVisitLocationCurrentLocationButton: 'Obter localização atual',
    dashboardClientVisitLocationRegisterCount: 'Registros',
    dashboardClientVisitLocationClientPopUp: 'Cliente',
    dashboardClientVisitLocationOrderPopUp: 'Pedido(s)',
    dashboardClientVisitLocationVendorPopUp: 'Vendedor',
    dashboardClientVisitLocationJustificationPopUp: 'Justificativa',
    dashboardClientVisitLocationTimeStayPopUp: 'Tempo de permanência',
    dashboardClientVisitLocationCheckinPopUp: 'Dt. Checkin',
    dashboardClientVisitLocationCheckoutPopUp: 'Dt. Checkout',
    dashboardClientVisitLocationSeeOrderPopUp: 'Visualizar pedido',
    dashboardClientVisitLocationWithoutSalesPopUp: 'Sem vendas',

    //USER-LIST
    userListTitle: 'Usuários',
    userListButtonAdd: 'Novo usuário',
    userListTableHeaderExternalCode: 'Código',
    userListTableHeaderName: 'Nome',
    userListTableHeaderEmail: 'Email',
    userListTableHeaderUserRole: 'Função',
    userListTableHeaderInative: 'Ativo?',
    userListTableHeaderCreatedAt: 'Dt. criação',
    userListTableHeaderUpdatedAt: 'Dt. atualização',
    userListUserQuant: 'Quantidade de usuários: {length}',

    //USER-FORM
    userFormTitle: 'Cadastro de Usuário',
    userFormButtonEdit: 'Atualizar usuário',
    userFormButtonNew: 'Criar usuário',
    userFormLabelExternalCode: 'Código vendedor',
    userFormLabelRoleExternalCode: 'Código cargo',
    userFormLabelNickname: 'Apelido',
    userFormLabelName: 'Nome Completo',
    userFormLabelUserRole: 'Cargo',
    userFormLabelSuperiorExternalCode: 'Supervisor',
    userFormLabelEmail: 'Email',
    userFormLabelPassword: 'Senha',
    userFormLabelPasswordConfirm: 'Confirme a Senha',
    userFormLabelUserSubsidiaries: 'Filiais',
    useFormLabelPhone1: 'Telefone 1',
    useFormLabelPhone2: 'Telefone 2',
    userFormLabelAllowVendorTracking: 'Permitir Cerca Virtual para o usuário',
    useFormLabelUseMarginControlByColor: 'Utiliza controle de margem por cor',
    userFormPasswordResetNextLogin: 'Solicitar nova senha no proximo login',
    userFormLabelUseMandatoryMix: 'Utiliza mix obrigatório',
    userFormLabelInactive: 'Inativo',
    userFormLabelMaxDiscountPercentage: 'Desconto máximo permitido',
    userFormMessageRequiredName: 'Nome é obrigatório',
    userFormMessageRequiredNickname: 'Apelido é obrigatório',
    userFormMessageRequiredUserRole: 'Cargo é obrigatório',
    userFormMessageRequiredExternalCode: 'Código é obrigatório',
    userFormMessageRequiredApproveDiscount: 'Grupo de liberação é obrigatório',
    userFormMessageValidEmail: 'Digite um email válido',
    userFormMessageRequiredEmail: 'Email é obrigatório',
    userFormMessageRequiredUserSubsidiaries: 'Filial é obrigatório',
    userFormMessageMinPassword: 'A senha deve ter no mínimo 6 caracteres',
    userFormMessageRequiredPassword: 'Senha é obrigatório',
    userFormMessageRequiredMatchPassword: 'Confirmação de senha é obrigatório',
    userFormMessageRequiredField: 'O campo {label} é obrigatório',
    userFormMessageRequiredFieldArray: 'Este campo deve ser uma lista válida',
    userFormMessageMatchPassword: 'As senha devem ser iguais',
    userFormMessageLastSync: 'Última sincronização: {lastTimestamp} - Versão do app: {appVersion}',
    userFormMessageApproveDiscountNotVendor: 'Grupo de liberação é apenas para usuários com cargo de vendedor.',
    userFormCreatedSuccess: 'Usuário criado com sucesso!',
    userFormUpdatedSuccess: 'Usuário editado com sucesso!',
    userFormExcludeSuccess: 'Usuário excluído com sucesso!',
    userFormDeviceUpdatedSuccess: 'Dispositivo alterado',
    userFormDeviceExcludeSuccess: 'Dispositivo excluído com sucesso',
    userFormLiberationGroup: 'Grupo de Liberação de pedidos',
    userInactive: 'Não',
    userActive: 'Sim',
    userAll: 'Todos',

    //MANDATORY-MIX
    mandatoryMixListTitle: 'Mix Obrigatório',
    mandatoryMixListButtonAdd: 'Adicionar Mix',
    mandatoryMixFormLabelName: 'Nome',
    mandatoryMixFormLabelStarDate: 'Data início',
    mandatoryMixFormLabelEndDate: 'Data fim',
    mandatoryMixFormLabelDateTo: 'até',
    mandatoryMixFormLabelClient: 'Cliente(s)',
    mandatoryMixFormLabelSubsidiary: 'Filial(s)',
    mandatoryMixFormLabelClientClassification: 'Classificação',
    mandatoryMixFormMessageRequiredName: 'O nome é obrigatório',
    mandatoryMixFormWarningMinProduct: 'É necessário adicionar pelo menos um produto na lista.',
    mandatoryMixFormMessageRequiredDateRange: 'As datas de início e fim são obrigatórias',
    mandatoryMixFormWarningProduct: 'O produto  é obrigatório',
    mandatoryMixFormWarningDuplicationProduct: 'Existem produtos duplicados na lista.',
    mandatoryMixFormLabelClientGroup: 'Rede',
    mandatoryMixFormButtonNew: 'Criar Mix',
    mandatoryMixFormButtonEdit: 'Editar Mix',
    mandatoryMixFormWarningQuantity: 'Quantidade é obrigatória',
    mandatoryMixFormWarningMinQuantity: 'A quantidade não pode ser menor que 1',
    mandatoryMixFormUpdatedMessage: 'O mix obrigatório foi atualizado!',
    mandatoryMixFormCreatedMessage: 'O mix obrigatório foi criado!',
    mandatoryMixFormExcludeMessage: 'O mix obrigatório foi excluído',

    //MANDATORY-LIST
    mandatoryMixListTableHeaderName: 'Nome',
    mandatoryMixListTableHeaderBeginDate: 'Data inicial',
    mandatoryMixListTableHeaderEndDate: 'Data final',

    //RECOMMENDATION-TABLE
    recommendationTotalsTableTitle: 'Totais consolidados',
    recommendationTotalsGraphicTitle: 'Gráfico de {string}',
    recommendationMenagerLabel: 'Gerentes',
    recommendationSalesTotalLabel: 'Total de vendas',
    recommendationSupervisorLabel: 'Supervisores',
    recommendationVendorLabel: 'Vendedores',
    recommendationClientLabel: 'Cliente',
    recommendationDatesLabel: 'Datas',
    recommendationSuggestedClientsLabel: 'Clientes sugeridos',
    recommendationEffectiveClientsLabel: 'Clientes efetivados',
    recommendationProductRecommendedLabel: 'Produtos recomendados',
    recommendationClientsRecommendedLabel: 'Clientes recomendados',
    recommendationPotentialLabel: 'Potencial de vendas',
    recommendationSalesLabel: 'Vendas realizadas',
    recommendationSalesQuantityLabel: 'Quantidade de vendas',
    recommendationUneffectiveClientsLabel: 'Clientes não efetivados',
    recommendationGovernamentalCodeLabel: 'CNPJ',
    recommendationProductLabel: 'Produto',
    recommendationPotentialQuantityLabel: 'Quantidade potencial',
    recommendationUserMediaQuantityLabel: 'Quantidade média do vendedor',
    recommendationStateMediaQuantityLabel: 'Quantidade média do estado atuante',
    recommendationUserMediaTrimesterQuantityLabel: 'Media do ultimo trimestre do vendedor',
    recommendationStateMediaTrimesterQuantityLabel: 'Media do ultimo trimestre do estado atuante',
    //RECOMMENDATION-CHARTS
    recommendationComparativeLabel: '{first} x {second}',
    recommendationEffectiveLabel: 'Efetivados',
    recommendationUneffectiveLabel: 'Não efetivados',
    recommendationChartByLabel: 'de {string}',
    //CLIENT ORDERS MODAL
    clientOrdersModalTableTitle: 'Vendas realizadas',
    clientOrdersModalTableNumber: 'Número',
    clientOrdersModalTableSubsidiary: 'Filial',
    clientOrdersModalTableStatus: 'Status',
    clientOrdersModalTableTotal: 'Total',

    //SALES RESTRICTIONS
    salesRestrictionsLabelProductLine: 'Linha do produto',
    salesRestrictionsLabelProvider: 'Fornecedor',
    salesRestrictionsLabelSection: 'Seção',
    salesRestrictionsLabelBrand: 'Marca',
    salesRestrictionsLabelCaregory: 'Categoria',
    salesRestrictionsLabelDepartiment: 'Departamento',
    //TEAM-LIST
    teamListTitle: 'Times',
    teamListButtonAdd: 'Novo time',
    teamListTableHeaderId: 'ID',
    teamListTableHeaderName: 'Nome',
    teamListTableHeaderDescription: 'Descrição',
    teamListTableHeaderCreatedAt: 'Dt. criação',
    teamListTableHeaderUpdatedAt: 'Dt. atualização',
    //TEAM-FORM
    teamFormTitle: 'Cadastro de time',
    teamFormButtonEdit: 'Atualizar time',
    teamFormButtonNew: 'Criar time',
    teamFormLabelName: 'Nome',
    teamFormLabelDescription: 'Descrição',
    teamFormLabelUsers: 'Usuários',
    teamFormLabelAllowVendorTracking: 'Permitir Cerca Virtual para o time',
    teamFormLabelAllowTeamAccessKit: 'Permite apenas vendas de kits para o time',
    teamFormLabelUseMandatoryMix: 'Utiliza mix obrigatório',
    teamFormLabelMaxDiscountPercentage: 'Desconto máximo permitido',
    teamFormMessageRequiredName: 'Nome é obrigatório',
    teamFormMessageRequiredDescription: 'Descrição é obrigatório',
    teamFormCreatedSuccess: 'Time criado com sucesso!',
    teamFormUpdatedSuccess: 'Time editado com sucesso!',
    teamFormExcludeSuccess: 'Time excluído com sucesso',
    teamFoemMessageMinUsers: 'Usuários são obrigatórios',
    //REWARDS-LIST
    rewardsListTitle: 'Recompensas',
    rewardsListButtonAdd: 'Nova recompensa',
    rewardsListTableHeaderId: 'ID',
    rewardsListTableHeaderCode: 'Código',
    rewardsListTableHeaderLabel: 'Nome',
    rewardsListTableHeaderDescription: 'Descrição',
    rewardsListTableHeaderPrice: 'Preço',
    rewardsListTableHeaderRequiredPoints: 'Pontos',
    rewardsListTableHeaderCreatedAt: 'Dt. criação',
    rewardsListTableHeaderUpdatedAt: 'Dt. atualização',
    //REWARDS-FORM
    rewardsFormTitle: 'Cadastro de recompensa',
    rewardsFormButtonEdit: 'Atualizar recompensa',
    rewardsFormButtonNew: 'Criar recompensa',
    rewardsFormLabelLabel: 'Nome',
    rewardsFormLabelCode: 'Código',
    rewardsFormLabelDescription: 'Descrição',
    rewardsFormLabelPrice: 'Preço',
    rewardsFormLabelRequiredPoints: 'Pontos',
    rewardsFormLabelQuantity: 'Quantidade',
    rewardsMessageRequiredLabel: 'Nome é obrigatório',
    rewardsMessageRequiredDescription: 'Descrição é obrigatório',
    rewardsMessageMinPrice: 'Preço incorreto',
    rewardsMessageRequiredPrice: 'Preço é obrigatório',
    rewardsMessageMinRequiredPoints: 'Pontos incorreto',
    rewardsMessageRequiredRequiredPoints: 'Pontos é obrigatório',
    rewardsMessageMinQuantity: 'Quantidade incorreta',
    rewardsMessageRequiredQuantity: 'Quantidade é obrigatório',
    rewardsFormCreatedSuccess: 'Recompensa criada com sucesso!',
    rewardsFormUpdatedSuccess: 'Recompensa editada com sucesso!',
    rewardsFormExcludeSuccess: 'Produto excluído com sucesso',
    //SPONSORED-LIST
    sponsoredListTitle: 'Produtos patrocinados',
    sponsoredListButtonAdd: 'Novo produto',
    sponsoredListTableHeaderId: 'ID',
    sponsoredListTableHeaderProductExternalCode: 'Cód. Produto',
    sponsoredListTableHeaderProductName: 'Nome',
    sponsoredListTableHeaderDescription: 'Descrição',
    sponsoredListTableHeaderPointsMultiplier: 'Multiplicador',
    sponsoredListTableHeaderStartDate: 'Dt. inicial',
    sponsoredListTableHeaderEndData: 'Dt. final',
    sponsoredStatusExpired: 'Expirado',
    sponsoredStatusValid: 'Válido',
    //SPONSORED-FORM
    sponsoredFormTitle: 'Cadastro de produto patrocinado',
    sponsoredFormButtonEdit: 'Atualizar produto',
    sponsoredFormButtonNew: 'Criar produto',
    sponsoredFormLabelStarDate: 'Data inicial',
    sponsoredFormLabelEndDate: 'Data final',
    sponsoredFormLabelDescription: 'Descrição Beneficio/Prêmio',
    sponsoredFormLabelPointsMultiplier: 'Multiplicador',
    sponsoredFormLabelProduct: 'Produto',
    sponsoredFormLabelSendNotications: 'Notificar Usuários',
    sponsoredFormLabelUseTeams: 'Restringir por time',
    sponsoredFormLabelTeams: 'Times',
    sponsoredMessageRequiredStartDate: 'Data inicial obrigatória',
    sponsoredMessageRequiredEndDate: 'Data final obrigatória',
    sponsoredMessageRequiredDescription: 'Descrição é obrigatório',
    sponsoredMessageMinPointsMiltiplier: 'Valor mínimo',
    sponsoredMessageRequiredPointsMultiplier: 'Multiplicador é obrigatório',
    sponsoredMessageRequiredSelectedProduct: 'Nenhum produto selecionado',
    sponsoredMessageSearchPlaceholderNoOptions: 'Nenhum registro encontrado',
    sponsoredMessageSearchPlaceholderLoading: 'Carregando...',
    sponsoredFormCreatedSuccess: 'Produto criado com sucesso!',
    sponsoredFormUpdatedSuccess: 'Produto editado com sucesso!',
    sponsoredFormExcludeSuccess: 'Produto excluído com sucesso',
    //TRADING-LIST
    tradingListTitle: 'Motor de negociação',
    tradingListButtonAdd: 'Novo motor de negociação',
    tradingListTableHeaderName: 'Nome',
    tradingListTableHeaderUsersAssociated: 'Qtd. usuários',
    //TRADING-FORM
    tradingFormTitle: 'Cadastro de motor de negociação',
    tradingFormButtonEdit: 'Atualizar motor de negociação',
    tradingFormButtonNew: 'Criar motor de negociação',
    tradingFormButtonMinimumMargin: 'Margin minima item',
    tradingFormLabelTeam: 'Time',
    tradingFormLabelMinimumMarginUser: 'Margem mínima RCA',
    tradingFormLabelMinimumMarginOrder: 'Margem mínima pedido',
    tradingFormLabelMinimumMarginItem: 'Margem mínima item',
    tradingMessageMinMinimumMarginUser: 'Valor incorreto margem mínima RCA',
    tradingMessageRequiredMinimumMarginUser: 'Margem mínima RCA é obrigatório',
    tradingMessageMinMinimumMarginOrder: 'Valor incorreto margem pedido',
    tradingMessageRequiredMinimumMarginOrder: 'Margem mínima pedido é obrigatório',
    tradingFormCreatedSuccess: 'Motor de negociação criado com sucesso!',
    tradingFormUpdatedSuccess: 'Motor de negociação editado com sucesso!',
    tradingFormExcludeSuccess: 'Motor de negociação excluído com sucesso',
    //FEATURE NOT IMPLEMENTING
    featureNotImplementingTitle: 'Funcionalidade não implementada',
    featureNotImplementingMessage: 'Essa feature ainda não foi implementada.',
    //ACTION ALERT
    actionAlertButtonClose: 'Fechar',
    actionAlertButtonCancel: 'Cancelar',
    actionAlertButtonConfirm: 'Confirmar',
    //ORDER
    orderTitle: 'Meus Pedidos',
    orderButtonAdd: 'Novo Pedido',
    orderTableHeaderId: 'ID',
    orderTableHeaderOrderNumber: 'Pedido',
    orderTableHeaderOrderExternalNumber: 'Pedido ERP',
    orderTableHeaderOrderInvoiceNumber: 'Nota Fiscal',
    orderTableHeaderClient: 'Cliente',
    orderTableHeaderSubsidiary: 'Filial',
    orderTableHeadeUser: 'Vendedor',
    orderTableHeaderOrderStatus: 'Status',
    orderTableHeaderIsExternal: 'Externo',
    orderTableHeaderTotalValue: 'Total em Valor (R$)',
    orderTableHeaderTotalWithTaxes: 'Total + Imposto (R$)',
    orderTableHeaderAttendedTotalPrice: 'Total atendido',
    orderTableHeaderEstimatedDeliveryDate: 'Dt. previsão de entrega',
    orderTableHeaderTotalWeight: 'Total em Peso (KG) ',
    orderTableHeaderVendor: 'Vendedor',
    orderTableHeaderCreatedAt: 'Dt. criação',
    orderTableHeaderUpdatedAt: 'Dt. atualização',
    orderTableTotalOrders: 'Total dos pedidos (R$)',
    orderTableConfirmedTotalOrders: 'Total atendido (R$)',
    orderTableTotalOrdersLoading: 'Carregando',
    orderTableConfirmedTotalOrdersLoading: 'Carregando',
    orderFilterTitle: 'Filtro de Pedidos',
    orderFilterStatus: 'Status',
    orderFilterPeriod: 'Período',
    orderFilterClient: 'Cliente',
    orderFilterFiliais: 'Filiais',
    orderFilterOrderType: 'Tipo de Pedido',
    orderFilterOrderExternalNumber: 'Número do pedido ERP',
    orderFilterIsExternal: 'Apenas Pedidos Externos (ERP)',
    orderFilterInvoiceNumber: 'Número da Nota Fiscal',
    orderFilterApply: 'Aplicar Filtros',
    orderFormExcludeSuccess: 'Pedido excluído com sucesso',
    orderFormResendSuccess: 'Pedido reenviado com sucesso',
    orderFormLabelExcludeBudgetTitle: 'Cancelamento',
    orderFormLabelExcludeBudgetMessage: 'Deseja cancelar esse orçamento?',
    orderFormLabelExcludeSuccess: 'Orçamento cancelado com sucesso',
    orderFormNewOrderModalOnLocalStorageTitle: 'Novo pedido',
    orderFormNewOrderModalOnLocalStorageMessage: 'Parece que você tem um pedido não finalizado, deseja continuar?',
    orderFormNewOrderModalOnLocalStorageButtonRecovery: 'Recuperar',
    orderFormNewOrderModalOnLocalStorageButtonDiscard: 'Descartar',

    //ORDER-DETAIL
    orderDetailTab1: 'Pedido Principal',
    orderDetailTab2: 'Bonificação Vinculada',

    orderDetailTitle: 'Pedido',
    orderDetailLabelStatus: 'Status',
    orderDetailLabelSubsidiary: 'Filial',
    orderDetailLabelSubsidiaryExternalCode: 'Código',
    orderDetailLabelSubsidiaryName: 'Nome: ',
    orderDetailLabelShippingType: 'Frete',
    orderDetailLabelDate: 'Data',
    orderDetailLabelClientOrder: 'Pedido cliente',
    orderDetailLabelVinculatedOrderExternalNumber: 'Vinculado ao pedido',
    orderDetailLabelReferenceOriginalOrderNumber: 'Número de ref. pedido original',
    orderDetailLabelOrderTotalPrice: 'Total',
    orderDetailLabelOrderAttendedTotalPrice: 'Total atendido',
    orderDetailLabelDateIntegrationERP: 'Data de integração',
    orderDetailLabelNumber: 'Nº do doc.',
    orderDetailCopyButton: 'Copiar pedido',
    orderDetailPaymentButton: 'Link de Pagamento',
    orderCancelButtonText: 'Cancelar Pedido',
    orderCancelConfirmTitleDialog: 'Cancelamento de pedido',
    orderCancelConfirmTextDialog: 'Insira o motivo do cancelamento do pedido',
    orderDetailPaymentPixButton: 'QR Code Pix',
    orderDetailComplementaryButton: 'Criar pedido complementar',
    orderDetailBudgetButton: 'Abrir orçamento',
    //ORDER-DETAIL-vendor
    orderDetailLabelVendor: 'Vendedor',
    orderDetailLabelVendorName: 'Nome:',
    orderDetailLabelVendorPhones: 'Telefones:',
    orderDetailLabelVendorEmail: 'Email:',
    //ORDER-DETAIL-client
    orderDetailLabelClient: 'Cliente',
    orderDetailLabelClientExternalCode: 'Código:',
    orderDetailLabelClientName: 'Nome:',
    orderDetailLabelClientGovernmentalCode: 'CNPJ:',
    orderDetailLabelClientDeliveryInfo: 'Endereço de entrega',
    orderDetailLabelClientDeliveryInfoAddress: 'Endereço: ',
    orderDetailLabelClientDeliveryInfoPostalCode: 'CEP: ',
    orderDetailLabelClientDeliveryInfoCity: 'Cidade: ',
    orderDetailLabelClientDeliveryInfoPhoneNumber: 'Telefone: ',
    orderDetailLabelPaymentOption: 'Cobrança',
    orderDetailLabelPaymentPlan: 'Plano de pagamento',
    orderDetailLabelObservation: 'Observação',
    orderDetailLabelOrderObservation: 'Observação do pedido',
    orderDetailLabelOrderObservationItens: 'Observação dos itens',
    orderDetailLabelError: 'Erro no pedido',
    //ORDER-DETAIL-item
    orderDetailLabelProduct: 'Produto',
    orderDetailLabelSoldPrice: 'Vlr. unitário (sem imposto)',
    orderDetailLabelTaxValue: 'Vlr. imposto',
    orderDetailLabelReductionValue: 'Vlr. redução',
    orderDetailLabelTotalNetWeight: 'Peso Líq. Total:',
    orderDetailLabelTotalGrossWeight: 'Peso Bruto Total:',
    orderDetailLabelEstimatedDeliveryDate: 'Dt. previsão de entrega:',
    orderDetailLabelSoldPriceWithTax: 'Vlr. unitário (com imposto)',
    orderDetailLabelPriceTributeIpi: 'Valor Tributo IPI',
    orderDetailLabelPackingPrice: 'Vlr. da embalagem',
    orderDetailLabelSoldQuantity: 'Quantidade',
    orderDetailLabelSoldQuantityMultiple: 'Quantidade multipla de {multiple}x',
    orderDetailLabelNetWeight: 'Peso Líq. (Kg)(Unit.)',
    orderDetailLabelGrossWeight: 'Peso Bruto (Kg)(Unit.)',
    orderDetailLabelConfirmedQuantity: 'Quantidade Atendida',
    orderDetailLabelDiscountPercentage: 'Desconto',
    orderDetailLabelTabulatedPrice: 'Vlr. tabela',
    orderDetailLabelTotalItem: 'Total (sem imposto)',
    orderDetailLabelTotalItemWithTax: 'Total (com imposto)',
    orderDetailLabelExternalCode: 'Código',
    orderDetailLabelBrand: 'Marca',
    orderDetailLabelItemObservation: 'Observação',
    orderDetailLabelItemPacking: 'Embalagem',
    orderDetailLabelItemQuantity: 'Quantidade',
    orderDetailLabelItemConfirmedQuantity: 'Quantidade atendida',
    orderDetailLabelItemConfirmedValue: 'Valor atendido',
    orderDetailLabelComplement: 'Complem.',
    orderDetailLabelPaymentPlanGroup1Total: 'Total Ético',
    orderDetailLabelPaymentPlanGroup2Total: 'Total Genérico',
    orderDetailLabelTax: 'Impostos',
    orderDetailLabelReduction: 'Redução',
    orderDetailLabelTotal: 'Total (sem impostos)',
    orderDetailLabelTotalWithTax: 'Total (com impostos)',
    //ORDER DISCOUNT
    orderDetailLabelNotificationTitleApprove: 'Deseja liberar o pedido?',
    orderDetailLabelNotificationButtonApprove: 'Confirmar liberação',
    orderDetailLabelNotificationTitleReject: 'Deseja rejeitar o pedido?',
    orderDetailLabelNotificationButtonReject: 'Confirmar rejeição',
    orderDetailLabelNotificationMessage: 'Pedido bloqueado pela regra de desconto.',
    orderDetailLabelRejectReason: 'Motivo rejeição',
    orderDetailLabelApproveDetails: 'Detalhes de aprovação',
    orderDetailLabelRejectedDetails: 'Detalhes de rejeição',
    orderDetailLabelApprover: 'Aprovador',
    orderDetailLabelWithoutMaxDiscount: 'Você não tem alçada de desconto suficiente para esta operação!',
    orderDetailLabelAcceptedMessage: 'Pedido aprovado pelo controle pedidos!',
    orderDetailLabelRejectedMessage: 'Pedido rejeitado pelo controle pedidos!',
    orderDetailLabelNotificationButtonCancel: 'Cancelar',
    orderDetailLabelShippingPrice: 'Frete',
    orderDetailLabelTotalBonificated: 'Total Bonificado',
    orderDetailBudgetExpired: 'Orçamento expirado',
    orderDetailWithoutValidOrderItems: 'Parece que não tem nenhum produto válido para adicionar ao carrinho!',
    orderDetailInvalidPromotions:
      'Produto #{externalCode} - {name}, não existe promoção vinculada e será atualizado em caso de cópia ou abertura de orçamento.',
    orderDetailInvalidPromotionsWithBlock:
      'Produto #{externalCode} - {name}, não existe promoção vinculada e será removido do orçamento.',
    orderDetailCartIsLessQuantity:
      'Quantidade de produtos no carrinho está diferente do pedido original. Quantidade original: {initialQuantity}, Quantidade Atual: {currentQuantity}',
    orderDetailBlockBatch:
      'Não há lote do(s) produto(s) {productName} com data de vencimento maior ou igual a {minBatchExpiryDays} dias. A quantidade disponível é de {totalAvailableInValidBatches}',
    orderDetailBlockBatchRemove:
      'O produto {productName} foi removido pois não há lotes válidos com vencimento acima de {minBatchExpiryDays} dias.',
    orderDetailBlockBatchQuantity:
      'A quantidade do produto {productName} foi reduzida para {totalAvailableInValidBatches} devido ao limite de lotes válidos disponíveis.',

    //ORDER BONIFICATION APPROVE AND REJECT
    orderDetailBonificationLabelTitleApprove: 'Deseja liberar o pedido?',
    orderDetailBonificationLabelButtonApprove: 'Confirmar liberação',
    orderDetailBonificationLabelMessageApprove: 'Pedido bloqueado.',
    orderDetailBonificationLabelErrorMessageApprove: 'Pedido não encontrado',
    orderDetailBonificationLabelMessageApproved: 'Pedido liberado com sucesso!',
    orderDetailBonificationLabelButtonCancelApprove: 'Cancelar',

    orderDetailBonificationLabelTitleReject: 'Deseja rejeitar o pedido?',
    orderDetailBonificationLabelButtonReject: 'Confirmar rejeição',
    orderDetailBonificationLabelMessageReject: 'Pedido bloqueado pelo controle de bonificação',
    orderDetailBonificationLabelMessageRejected: 'Pedido rejeitado pelo controle de bonificação!',
    orderDetailBonificationLabelErrorMessageReject: 'Ocorreu um erro ao rejeitar a bonificação',
    orderDetailBonificationLabelButtonCancelReject: 'Cancelar',

    //ORDER STATUS
    orderStatusAll: 'Todos os Status',
    orderStatusOnDelivery: 'Em Transporte ',
    orderStatusDelivered: 'Entregue',
    orderStatusWaitingApproval: 'Aguardando Aprovação',
    orderStatusBudget: 'Orçamento',
    orderStatusProcessing: 'Processando',
    orderStatusAccepted: 'Aprovado',
    orderStatusBilled: 'Faturado',
    orderStatusBlocked: 'Bloqueado',
    orderStatusWaitingPayment: 'Aguardando Pagamento',
    orderStatusPending: 'Pendente',
    orderStatusReleased: 'Liberado',
    orderStatusMounted: 'Montado',
    orderStatusPaid: 'Pago',
    orderStatusRejected: 'Rejeitado',
    orderStatusError: 'Erro',
    orderStatusCanceled: 'Cancelado',
    orderStatusWaitingLoad: 'Aguardando carga',
    orderStatusLoaded: 'Carregado',
    orderStatusPartialReleased: 'Liberado Parcialmente',
    orderStatusInPartialStock: 'Estoque Parcial',
    orderStatusStock: 'Estoque',
    orderStatusWaitingPartialBilling: 'Aguardando Faturamento Parcial',
    orderStatusWaitingBilling: 'Aguardando Faturamento',
    orderStatusCanceledSupervisor: 'Cancelado pela Supervisão',
    orderStatusCanceledItem: 'Cancelado por Corte',
    orderStatusCanceledMinimumValue: 'Cancelado por Valor Mínimo',
    orderStatusCanceledWeb: 'Cancelado pelo Televendas',
    orderStatusCanceledBudget: 'Orçamento Cancelado',
    orderStatusReturned: 'Devolvido',
    orderStatusOriginalSplit: 'Pedido Original (Divisão de pedido)',
    orderStatusAwaitingSync: 'Aguardando Sincronização',
    orderStatusbudgetERP: 'Orçamento ERP',
    orderStatusWaitingERP: 'Aguardando ERP',
    orderStatusAvaliable: 'Disponível',
    orderStatusPartialBilled: 'Faturado Parcialmente',
    orderStatusSyncronized: 'Sincronizado',
    //DATE RANGE PICKER
    dateRangePickerComparative: 'Periodo de comparação',
    //ORDER CREATE
    orderCreateTitle: 'Novo pedido',
    orderCreateTabStep1: 'Cliente',
    orderCreateTabStep2: 'Produto',
    orderCreateTabStep3: 'Carrinho',
    orderCreateTabStep4: 'Checkout',
    orderCreateTab: 'Produto',
    orderCreateTitleClientChoose: 'Escolha o cliente',
    orderCreateTitleData: 'Dados do pedido',
    orderCreateTitlePayment: 'Dados do pagamento',
    orderCreateSearchClientInputPlaceholder: 'Digite aqui o código/ nome/ cidade ou cnpj do cliente',
    orderCreateLabelTypeOrder: 'Tipo de pedido',
    orderCreateLabelTypeBonification: 'Tipo de Bonificação',
    orderCreateLabelTypeOrderBonification: 'Bonificação',
    orderCreateLabelTypeOrderCollect: 'Retira',
    orderCreateLabelTypeOrderNormal: 'Normal',
    orderCreateLabelParentOrder: 'Pedido Selecionado',
    orderCreateLabelMinimumValue: 'Valor Mínimo:',
    orderCreateLabelMaximumValue: 'Valor Máximo:',
    orderCreateLabelSubsidiary: 'Filial',
    orderCreateLabelShippingType: 'Frete',
    orderCreateLabelSubsidiaryStock: 'Filial retira',
    orderCreateLabelLoadType: 'Modalidade',
    orderCreateLabelUseDeliveryProvider: 'Utilizar Frete redespacho?',
    orderCreateLabelDeliveryProvider: 'Frete redespacho',
    orderCreateLabelPaymentOption: 'Forma de pagamento',
    orderCreateLabelPaymentPlan: 'Plano de pagamento',
    orderCreateLabelPaymentPlan1: 'Plano de pagamento (Ético)',
    orderCreateLabelPaymentPlan2: 'Plano de pagamento (Genérico)',
    orderCreateLabelPaymentPlanNoOptions: 'Nenhum plano encontrado',
    orderCreateLabelMinPayment: 'Valor mínimo do pedido',
    orderCreateLabelClientEmptyRating: 'Cliente não possui avaliações, avalie-o antes de iniciar uma venda.',
    orderCreateLabelClientRatingDeadline: 'Prazo máximo para avaliar cliente está expirado.',
    orderCreateLabelTitleReasonPasswordModal: 'Senha para desbloqueio',
    orderCreateLabelDescriptionReasonPasswordModal: 'Insira a senha cadastrada no motivo para desbloquear o cliente.',
    orderCreateLabelInputReasonPasswordModal: 'Senha',
    orderCreateLabelPasswordErrorReasonPasswordModal: 'Senha é obrigatória',

    orderCreateLabelSelectOneVendor: 'Selecione um vendedor',
    orderCreateLabelVendor: 'Vendedor externo',

    orderCreateLabelRequiredBasket:
      'Para fazer um pedido normal, é necessário emitir um pedido do tipo "Cesto" primeiro.',

    orderCreateModalBonificationTitle: 'Pedidos',
    orderCreateModalBonificationMessage: 'Selecione um pedido para vincular a bonificação',
    orderCreateModalBonificationMessageSuccess: 'Pedido #{orderNumber} selecionado com sucesso',

    orderCreateButtonSell: 'Iniciar venda',
    orderCreateMessageRequiredClient: 'Cliente é obrigatório',
    orderCreateMessageRequiredDelivery: 'Transportadora é obrigatória',
    orderCreateMessageRequiredSubsidiary: 'Filial é obrigatório',
    orderCreateMessageRequiredShippingType: 'Frete é obrigatório',
    orderCreateMessageRequiredSubsidiaryStock: 'Filial retira é obrigatório',
    orderCreateMessageRequiredPaymentOption: 'Forma de pagamento é obrigatório',
    orderCreateMessageRequiredPaymentPlan: 'Plano de pagamento é obrigatório',
    orderCreateMessageRequiredPaymentPlanGroup: 'Grupo de pagamento é obrigatório',
    orderCreateMessageRequiredPaymentPlan1: 'Plano de pagamento(Ético) é obrigatório',
    orderCreateMessageRequiredPaymentPlan2: 'Plano de pagamento(Genérico) é obrigatório',
    orderCreateClientSearchPlaceholder: 'Pesquisar cliente',
    orderCreateClientSearchPlaceholderLoading: 'Carregando...',
    orderCreateClientSearchPlaceholderNoOptions: 'Nenhum registro encontrado',
    orderCreateClientSearchPlaceholderSearchClient: 'Digite o nome do cliente',
    orderCreateClientSearchButton: 'Consulta de Clientes / Filtros',
    orderCreateCartButton: 'Resumo do carrinho',
    orderCreateCartButtonEmpty: 'Nenhum item no carrinho',
    orderCreateCartEmpty: 'Nenhum item no carrinho',
    orderCreateProductSearchEmpty: 'Digite ao menos um caractere para pesquisar',
    orderCreateProductSearchPlaceholder: 'Digite aqui o nome do produto',
    orderCreateProductPromotionKitSearchPlaceholder: 'Digite aqui o nome do kit/combo/cód produto/cód promoção',
    orderCreateProductHasPromotion: 'Com promoção',
    orderCreateProductHasStock: 'Com estoque',
    orderCreateProductOnlyExternalCode: 'Buscar apenas código do produto',
    orderCreateProductOrderBy: 'Ordenar por',
    orderCreateProductOrderByAll: 'Todos',
    orderCreateProductOrderByLittle: 'Menor',
    orderCreateProductOrderByBig: 'Maior',
    orderCreateProductItems: '{option} Itens',
    orderCreateProductListEmpty: 'Nenhum produto encontrado',
    orderCreateProductListSearch: 'Utilize a busca para encontrar os produtos',
    orderCreateProductRecommend: 'Produtos Recomendados',
    orderCreateProductPromotionKit: 'Promoção Kit/Combo',
    orderCreateGoToCart: 'Ir para o carrinho',
    orderCreateGoToCheckout: 'Ir para o Checkout',
    orderCreateBack: 'Voltar',
    orderCreateViews: 'Você visualizou',
    orderCreateViewsSeparator: 'de',
    orderCreateViewsProducts: 'produtos',
    orderCreateCartTitle: 'Itens do carrinho',
    orderCreateCartListTitle: 'Produto',
    orderCreateCartListTitleUnitPrice: 'Preço unitário',
    orderCreateCartListTitleQuantity: 'Quantidade',
    orderCreateCartListTitleTotalPrice: 'Preço total',
    orderCreateCartRemoveItemTitle: 'Retirar produto do carrinho',
    orderCreateCartRemoveItemMessage: 'Deseja retirar este produto do carrinho?',
    orderCreateCheckoutTypeTitle: 'Tipo',
    orderCreateCheckoutTypeOrder: 'Pedido',
    orderCreateCheckoutTypeWaitingApproval: 'Revisão de pedido',
    orderCreateCheckoutVinculatedBonification: 'Bonificação vinculada',
    orderCreateCheckoutValidateSubsidiary: 'Filiais para divisão de pedido',
    orderCreateCheckoutTypeBudget: 'Orçamento',
    orderCreateCheckoutBillingDate: 'Data para o Faturamento do pedido',
    orderCreateCheckoutTypeBudgetValidate: 'Validade',
    orderCreateCheckoutClientTitle: 'Cliente',
    orderCreateSendInfos: 'Enviar informações do pedido',
    orderCreateCheckoutClientEmail: 'E-mail',
    orderCreateCheckoutClientEmailRequired: 'E-mail obrigatório',
    orderCreateCheckoutClientEmailValid: 'E-mail inválido',
    orderCreateCheckoutClientShippingDateRequired: 'Data obrigatória',
    orderCreateCheckoutClientShippingDateValid: 'Data inválida',
    orderCreateCheckoutClientMinShippingDateValid: 'A data não pode ser anterior ao dia de hoje',
    orderCreateCheckoutClientMaxShippingDateValid: 'A data não pode ser posterior a {date}',
    orderCreateCheckoutClientDeliveryAddressCodeRequired: 'Endereço de entrega obrigatório',
    orderCreateCheckoutClientTel: 'Telefone (whatsapp)',
    orderCreateCheckoutClientTelRequired: 'Telefone obrigatório',
    orderCreateCheckoutClientTelLength: 'Telefone deve conter 11 digitos (Ex.: 81 98888-7777)',
    orderCreateCheckoutShippingTitle: 'Frete',
    orderCreateCheckoutShippingAddress: 'Endereço entrega',
    orderCreateCheckoutShippingDate: 'Data prevista da entrega',
    orderCreateCheckoutShippinglabel: 'Escolha uma opção de frete',
    orderCreateCheckoutShippingNormal: 'Normal',
    orderCreateCheckoutShippingExpress: 'Expresso',
    orderCreateCheckoutShippingDays: 'dias úteis',
    orderCreateCheckoutShippingFree: 'Gratuito',
    orderCreateCheckoutOrderNumber: 'Número do pedido',
    orderCreateCheckoutObservationBudget: 'Observações do',
    orderCreateCheckoutObservationNote: 'Observações da nota',
    orderCreateCheckoutOrderSummaryPerProvider: 'Total por Fornecedor',
    orderCreateCheckoutOrderOtherExpenses: 'Outras despesas',
    orderCreateCheckoutObservationAccountBalance: 'Observações conta corrente',
    orderCreateCartSendEmail: 'Enviar cópia do {typeOrder} por email',
    orderCreateProductAllowMixClientFilter: 'Mix do cliente',
    orderDownloadPDF: 'Download PDF',
    orderDownloadExcel: 'Download Excel',
    orderExportScreenPDF: 'Exportar Tela em PDF',
    orderCreateCartErrorText: 'Existem pendências no',
    orderCartErrorTitle: 'Atenção',
    orderCartErrorAction: 'Abrir',
    orderCreateFinish: 'Finalizar',
    orderCreateCheckoutObservationMaxLength:
      'O número de caracteres da observação do pedido não pode exceder {maxLength}',
    orderCreateCheckoutDeliveryObservationMaxLength:
      'O número de caracteres da observação da nota não pode exceder {maxLength}',
    //ORDER CHECKOUT PENDENCIES
    orderCheckoutHasItemsRequiredByPromotion:
      'A promoção #{promoID} - {promoName} tem como obrigatório o produto {externalCode}, com quantiade minima {minQuantity}',
    orderCheckoutHasItemsWithZeroQuantity: 'Existe(m) item(s) com quantidade zero',
    orderCheckoutHasItemsBelowMininumPrice: 'Existe(m) item(s) com preço abaixo do mínimo',
    orderCheckoutHasItemsAboveDiscountAllowed: 'Existe(m) item(s) com desconto acima do permitido',
    orderCheckoutHasItemsBelowMininumPriceAcceptBlockedSale:
      'Existe(m) item(s) com preço abaixo do mínimo, revise o seu carrinho antes de continuar.',
    orderCheckoutHasItemsBelowMininumPriceNegotiation:
      ' Existe(m) item(s) com preço abaixo do mínimo, será necessário solicitar aprovação.',
    orderCheckoutHasItemsBelowMininumPriceInPromotion:
      'A promoção #{promoID} - {promoName} tem um valor minimo de {minimumPrice}, faltam {remainingPrice} para que possa ser utilizada.',
    orderCheckoutWithoutStock:
      'O produto #{externalCode} - {productName} não possui estoque suficiente disponível. Quantidade disponível: {availableQuantity} - Quantidade selecionada: {soldQuantity}.',
    orderCheckoutHasItemsWithoutQuantityInPromotion:
      'A promoção #{promoID} - {promoName} está com a quantidade fora do range requerido, quantidade no carrinho: {totalQuantity}, range esperado {initialQuantity}/{finalQuantity}.',
    orderCheckoutMinimumOrderTypeValue:
      'O valor total do pedido é menor que o valor mínimo do tipo de pedido selecionado. Valor mínimo: {string}',
    orderCheckoutMaximumOrderTypeValue:
      'O valor total do pedido é maior que o valor máximo do tipo de pedido selecionado. Valor máximo: {string}',
    orderCheckoutMinimumPaymentPlanValue:
      'O valor total do pedido é menor que o valor mínimo do plano de pagamento selecionado. Valor mínimo: {string}',
    orderCheckoutBlockCreditExceededNewOrder:
      'Cliente bloqueado para novos pedidos pelo motivo {reason}. Limite de crédito {creditLimit}, limite de crédito disponível {availableCredit}, excedito em {remainCredit}',
    orderCheckoutBlockCreditOverdueExceededNewOrder:
      'Cliente bloqueado para novos pedidos pelo motivo exceder o limite padrão de crédito de {percentage}. Limite de crédito {creditLimit}, limite de crédito disponível {availableCredit}, excedito em {remainCredit}',
    orderCheckoutBlockCreditExceededAnlyCach:
      'Cliente bloqueado para vendas a prazo, pelo motivo {reason}. Limite de crédito {creditLimit}, limite de crédito disponível {availableCredit}, excedito em {remainCredit}',
    orderCheckoutStockIsChanged: 'Filial retira {subsidiary} selecionada',
    orderCheckoutLoadControl:
      'O pedido possui controle de carga fechada. Após salvar realize a inclusão do mesmo em uma carga disponível.',
    orderCheckoutBalanceOrderMinimumValueERP:
      'Existe(m) item(s) com preço abaixo do mínimo, o pedido será bloqueado pelo ERP.',
    orderCheckoutBalanceOrderInsufficientERP: 'Você não tem saldo suficiente, o pedido será bloqueado pelo ERP.',
    orderCheckoutBalanceAmountInsufficient:
      'Você não tem saldo suficiente para finalizar esse pedido. Saldo atual: {amount}',
    orderCheckoutShippingPriceRemaing: 'Faltam {price} para obter o frete gratuito.',
    orderCheckoutMaxLimitBalance: 'O valor mínimo da conta-corrente é {price}',
    orderCheckoutMarginIsBellowMargin: 'A margem total do pedido está abaixo do mínimo {percentage}%',
    orderCheckoutMinimumValuePaymentPlan:
      'O valor total do pedido é menor que o valor mínimo do grupo de plano de pagamento selecionado. {name}, valor mínimo: {minimumPrice}',
    orderCheckoutHasItemsWithHigherDiscountPercentage:
      'Existe(m) item(s) com desconto acima do permitido, revise o seu carrinho antes de continuar.',
    orderCheckoutOrderMinimumValue: 'O valor total do pedido é menor que o valor mínimo necessário. {minimumPrice}',
    orderCheckoutRequiredAdditionalProductToKit: 'O pedido requer um produto adicional que não seja do mesmo combo/kit',
    orderRemoveItemsSubsidiaryChangedMessage: 'Filial alterada, produtos removidos do carrinho.',
    //CLIENT BLOCK REASONS
    orderClientBlockNewOrders: 'Cliente bloqueado para novos pedidos desde {blockedDate} pelo motivo {description}.',
    orderClientBlockCreditExceeded: 'Cliente bloqueado para novos pedidos pelo motivo {description}.',
    orderClientBlockNonPayment: 'Cliente bloqueado para novos pedidos pelo motivo {description}.',
    orderClientBlockAnlyCashWithDate:
      'Cliente bloqueado para vendas a prazo desde {blockedDate} pelo motivo {description}. Somente pedidos à vista estão disponíveis.',
    orderClientBlockAnlyCash:
      'Cliente bloqueado para vendas pelo motivo {description}. Somente pedidos à vista estão disponíveis.',
    orderSubsidiaryBlockAnlyCash:
      'Filial bloqueada para vendas pelo motivo {description}. Somente pedidos à vista estão disponíveis.',
    orderClientBlockNextVisit: 'Cliente bloqueado para novos pedidos pelo motivo {description}.',
    orderClientBlockSubsidiary: 'Filial bloqueada para novos pedidos pelo motivo {description}.',
    orderClientBlockSalesRestriction: 'Restrição de venda para a filial para novos pedidos pelo motivo: {description}.',
    orderSubsidiariesBlockAnlyCash:
      'Filial bloqueada para vendas a prazo pelo motivo {description}. Somente pedidos à vista estão disponíveis.',
    orderClientBlockNextVisitAnlyCash:
      'Cliente bloqueado para vendas a prazo pelo motivo {description}. Somente pedidos à vista estão disponíveis.',
    orderModalPasswordNotMatchMessage: 'A senha não confere. Contate um superior.',
    orderModalPasswordExpiryPasswordMessage: 'Senha expirada. Contate um superior para atualizá-la.',
    orderModalSuccessPasswordMessage: 'Cliente desbloqueado com sucesso!',
    //ORDER CREATE WARNINGS
    orderWarningClientChanged: 'Cliente alterado, produtos removidos do carrinho.',
    orderWarningProductAdd: 'Produto adicionado com sucesso!',
    orderWarningProductRemove: 'Produto removido do carrinho com sucesso!',
    orderWarningProductUpdated: 'Produto atualizado no carrinho com sucesso!',
    orderWarningProductQuantityBellow: 'Quantidade inferior a permitida, deseja remover este item do carrinho?',
    orderWarningProductBatchPromotionQuantity:
      'A promoção {promotionName} é vinculada ao lote {batchCode} e por isso a quantidade máxima permitida é de {quantity}',
    orderWarningProductQuantityMultiple:
      'Este produto possui quantidade múltipla de {quantityMultiple}x, a quantidade será redefinida para {newSoldQuantity}.',
    orderWarningPromotionApplied:
      'Promoção {promotionName} foi aplicada, deseja manter a quantidade inserida? Caso a quantidade esteja fora do intervalo da promoção, a quantidade será redefinida para {initialQuantity}. Caso saia do intervalo, a promoção será removida automáticamente.',
    orderWarningProductWithoutPromotion: 'Produto sem promoção atribuída não poderá ser incluso no carrinho.',
    orderWarningProductEditWithPromotion:
      'Este produto possui promoção(ões) disponível(eis) ou aplicada, deseja editá-lo?',
    orderWarningClientBlockRegulation: 'Esse produto está bloqueado para este cliente pelo motivo: {description}.',
    orderWarningCartEmpty: 'Sem itens no carrinho',
    orderWarningCartClean: 'Essa ação poderá atualizar/remover os produtos do carrinho, realmente deseja continuar?',
    orderWarningCartCleanSubsidiary:
      'Alterar a filial poderá atualizar/remover os produtos do carrinho, realmente deseja continuar?',
    orderWarningCartCleanPaymentOption:
      'Alterar a forma de pagamento  poderá atualizar/remover os produtos do carrinho, realmente deseja continuar?',
    orderWarningCartCleanPaymentPlan:
      'Alterar o plano de pagamento poderá atualizar/remover os produtos do carrinho, realmente deseja continuar?',
    orderWarningCartWasCleared: 'Todos os itens do carrinho foram removidos.',
    orderWarningOrderRestrictionWithReason: `Pedido bloqueado devido à restrição de venda #{restrictionExternalCode} {restrictionReason}.`,
    orderWarningOrderRestrictionWithoutReason: `Pedido bloqueado devido à restrição de venda #{restrictionExternalCode}.`,
    orderWarningRestrictionWithReason: `Pedido bloqueado devido à restrição de venda #{restrictionExternalCode} - {restrictionReason}.`,
    orderWarningRestrictionWithoutReason: `Pedido bloqueado devido à restrição de venda #{restrictionExternalCode}.`,
    orderWarningProductRestrictionWithReason:
      'O item #{productExternalCode} não pode ser adicionado ao carrinho pois possui restrição de venda #{restrictionExternalCode} - {restrictionReason}.',
    orderWarningProductRestrictionWithoutReason:
      'O item #{productExternalCode} não pode ser adicionado ao carrinho pois possui restrição de venda #{restrictionExternalCode}.',
    orderWarningProductQuota1: 'A quantidade máxima do produto #{productExternalCode}',
    orderWarningProductQuota2: 'para o cliente #{clientExternalCode} e',
    orderWarningProductQuota3: 'para a filial #{subsidiaryExternalCode} é de {quota} unidades.',
    orderWarningMultipleSubsidiaryProductQuantityMultiple:
      'Este produto possui quantidade múltipla de {quantityMultiple}x para essa filial, a quantidade será redefinida para {newSoldQuantity}.',
    orderWarningPromotionKitAlreadyAdded:
      'O kit #{promotionKitExternalCode} - {promotionKitName} já foi adicionado ao carrinho.',
    orderWarningPromotionEmpty: 'Remova o kit pelo botão de exclusão.',
    orderClientBlockRegulation: 'Cliente bloqueado para novos pedidos pelo motivo {description}.',
    orderClientBlockRegulationEmpty: 'Cliente ou produto sem alvará.',
    orderWarningProductBonificationRestriction:
      'O item {productExternalCode} não pode ser adicionado no carrinho pois possui restrição de {description}.',
    orderWarningWorkingTimeTitle: 'Encerramento Próximo',
    orderWarningWorkingTime: 'Atenção: Fim de turno em {minutesExact} minutos. Finalize seus pedidos em andamento.',
    orderWarningWorkingTimer: 'Fim do turno em:',
    //PRODUCT CARD
    productCardBrand: 'Marca',
    productCardSection: 'Seção',
    productCardPoints: 'Pontos',
    productCardUnit: 'Unidades',
    productCardStock: 'Estoque',
    productCardUnitPrice: 'Preço unitário',
    productCardUnitPriceWithMedPromotions: 'Preço de fábrica',
    productCardPromotionalPrice: 'Preço promocional',
    productCardSponsored: 'Patrocinado',
    productCardBonification: 'Produto bonificado',
    productCardCart: 'Produto no carrinho',
    productCardPromotion: 'Produto em promoção',
    productCardPositivationByVendor: 'Produto já vendido pelo vendedor no mês vigente',
    productCardPositivationByClient: 'Produto já vendido para o cliente no mês vigente',
    productCardIsTagFocus: 'Foco',
    productCardAssistedSale: 'Venda assistida',
    //CART RECOMMENDATIONS POPUP
    productCardRecommendation: 'Produto recomendado',
    cartRecommendationPopupAllProductsLoaded: 'Todos os produtos foram carregados',
    cartRecommendationPopupEmptyDescription: 'Adicione produtos ao carrinho para receber recomendações personalizadas',
    cartRecommendationPopupTitle: 'Produtos Recomendados para Você',
    cartRecommendationPopupSubtitle: 'Sugestões personalizadas baseadas nas vendas anteriores deste cliente.',
    cartRecommendationPopupOpenModalButton: 'Abrir detalhes',
    cartRecommendationPopupCloseButton: 'Fechar',
    cartRecommendationPopupRetryButton: 'Atualizar lista',
    cartRecommendationPopupDisableButton: 'Não quero recomendações',
    cartRecommendationPopupEmpty: 'Nenhuma recomendação disponível no momento.',
    cartRecommendationFloatingLabel: 'Recomendações',
    cartRecommendationFloatingTooltip: 'Abrir recomendações',
    cartRecommendationOpenButton: 'Ver Recomendações',
    //CART CARD
    cartCardActionDelete: 'Retirar do carrinho',
    //CART TOTAL
    cartTotalTitle: 'Resumo do carrinho',
    cartTotalProductQuantity: 'Quantidade de produtos',
    cartTotalCartItems: 'Quantidade de itens no carrinho',
    cartTotalProductPrice: 'Valor dos produtos',
    cartTotalProductBonificated: 'Valor dos bonificados',
    cartTotalProductPriceEthical: 'Ético',
    cartTotalProductPriceGenerical: 'Genérico',
    cartTotalProductTributes: 'Valor dos tributos',
    cartTotalProductFCP: 'Valor FCP',
    cartTotalProductIPI: 'Valor IPI',
    cartTotalProductST: 'Valor ST',
    cartTotalProductRepasse: 'Valor repasse',
    cartTotalProductICMSReduction: 'Valor redução ICMS',
    cartTotalProductPISReduction: 'Valor redução PIS',
    cartTotalProductCOFINSReduction: 'Valor redução COFINS',
    cartTotalProductTotalReduction: 'Valor redução total',
    cartTotalProductShipping: 'Valor do frete',
    cartTotalWeight: 'Peso total',
    cartTotalProductWithoutMarginControlByColor: 'Valor fora da margem por cor',
    cartTotalPrice: 'Valor total',
    cartTotalPriceWithTax: 'Valor total + tributos',
    cartTotalPoints: 'Pontos',

    //CLIENT PAGE
    clientPageTab1: 'Cliente',
    clientPageTab2: 'Fotos',
    clientPageTab3: 'Avaliações',
    clientPageTab4: 'Aprovação de Avaliação do cliente',

    //CLIENT MODAL
    clientModalTitle: 'Detalhes do CLiente',
    clientModalTab1: 'Cliente',
    clientModalTab2: 'Recomendação',
    clientModalTab3: 'Histórico',
    clientModalTab4: 'Navegar',
    clientModalTab5: 'Avaliações',
    clientModalTab6: 'Questionários',
    clientModalTab7: 'Referências',
    clientModalDateInitial: 'Data inicial',
    clientModalDateFinal: 'Data final',
    clientModalFilterButton: 'Filtrar',
    clientModalDateRangeInvalid: 'A data final não pode ser menor que a data inicial',
    clientModalHistoryOrderLast: 'Data da última compra',

    clientModalCardInfoCompanyText: 'Razão social',
    clientModalCardInfoGovernmentalCode: 'CPF/CNPJ',
    clientModalCardInfoSimpleNational: 'Simples nacional',
    clientModalPotential: 'Potencial do cliente',
    clientModalContactText: 'Contato',
    clientModalContactCellPhone: 'Telefone celular',
    clientModalContactComercialPhone: 'Telefone comercial',
    clientModalContactEmail: 'Email',
    clientModalComercialAddressText: 'Endereço Comercial',
    clientModalComercialAddressStreet: 'Endereço',
    clientModalComercialAddressNumber: 'Número',
    clientModalComercialAddressDistrict: 'Bairro',
    clientModalComercialAddressCity: 'Cidade',
    clientModalComercialAddressState: 'Estado',
    clientModalObservation: 'Observação',
    clientModalActivity: 'Ramo de negócio',
    clientModalDefaultPaymentOption: 'Forma de pagamento',
    clientModaldaysLatePaymentQuantity: 'Qtd de atraso dos últimos 3 meses',
    clientModalLimitText: 'Limites e Saldos',
    clientModalLimitCredit: 'Limite de crédito',
    clientModalLimitAvailableCredit: 'Limite de crédito disponível',
    clientModalLimitOpenBills: 'Contas a receber',
    clientModalLimitCurrentCredit: 'Crédito atual',
    clientModalLimitLastPurchaseDate: 'Data da última compra',
    //CLIENT MODAL HISTORY
    clientModalHistoryOrders: 'Pedidos',
    clientModalHistoryOrdersEmpty: 'Cliente sem pedidos até o momento',
    clientModalHistoryOrdersCreatedAt: 'Data',
    clientModalHistoryOrdersOrderExternalNumber: 'Pedido ERP',
    clientModalHistoryOrdersOrderExternalNumberEmpty: 'Não Possui',
    clientModalHistoryOrdersOrderNumber: 'Pedido ISA',
    clientModalHistoryOrdersClientName: 'Cliente',
    clientModalHistoryOrdersOrderType: 'Tipo',
    clientModalHistoryOrdersSubsidiaryExternalCode: 'Filial',
    clientModalHistoryOrdersTotalPrice: 'Valor Total',
    clientModalHistoryOrdersOrderStatus: 'Status',
    clientModalHistoryProducts: 'Produtos',
    clientModalHistoryProductsExternalCode: 'Código',
    clientModalHistoryProductsName: 'Descrição',
    clientModalHistoryProductsFinancialCost: 'Preço médio',
    clientModalHistoryProductsSoldQuantity: 'Quantidade',
    clientModalHistoryProductsEmpty: 'Sem produtos nos pedidos até o momento',
    clientModalHistoryFinancial: 'Títulos',
    clientModalHistoryFinancialEmpty: 'Cliente sem títulos até o momento',
    clientModalHistoryFinancialIssueDate: 'Emissão',
    clientModalHistoryFinancialInvoiceNumber: 'Nota Fiscal',
    clientModalHistoryFinancialName: 'Cobrança',
    clientModalHistoryFinancialValue: 'Valor',
    clientModalHistoryFinancialDueDate: 'Vencimento',
    clientModalHistoryFinancialPaymentDate: 'Status',
    clientModalHistoryFinancialPaymentDatePaid: 'Pago',
    clientModalHistoryFinancialPaymentDateLate: 'Atrasado',
    clientModalHistoryFinancialPaymentDateDiff: 'A vencer',
    clientModalHistoryFinancialPaymentDateDays: 'dias',
    clientModalHistoryFinancialPaymentDateBankSlip: 'Cód. de barras',

    // CLIENT MODAL CHECKLIST TAB
    clientModalChecklistEmpty: 'Nenhum questionário cadastrado no momento!',
    clientModalChecklistLengthQuestions: 'Qtd. de perguntas',
    clientModalChecklistRequired: 'Obrigatório?',
    clientModalChecklistCreatedAt: 'Criado em',
    clientModalChecklistUpdatedAt: 'Atualizado em',

    clientModalChecklistOpenHistory: 'Abrir histórico',
    clientModalChecklistResponse: 'Responder',
    clientModalChecklistResponseHistory: 'Visualizar questionário respondido',
    clientModalChecklistInputLabel: 'Mensagem',
    clientChecklistFormEmptyFields: 'Preencha todos os campos',
    clientChecklistFormSuccess: 'Resposta enviada com sucesso!',

    // Referencias modal
    clientModalReferenceEmpty: 'Nenhuma referência cadastrada no momento!',
    clientModalReferenceRegiserDialogTitle: 'Adicionar Referência',
    clientModalReferenceEnterpriseName: 'Nome da empresa de referência',
    clientModalReferenceEnterpriseContactName: 'Nome do contato da empresa',
    clientModalReferenceEmptyEnterpriseContactPhone: 'Telefone do contato',
    clientModalReferenceEnterpriseNameError: 'Nome da empresa necessário',
    clientModalReferenceEnterpriseContactNameError: 'Nome do contato necessário',
    clientModalReferenceEmptyEnterpriseContactPhoneError: 'Telefone para contato necessário',
    clientModalReferenceRegisterSuccess: 'Referência cadastrada com sucesso',
    clientModalReferenceRegisterError: 'Erro ao cadatrar referência',

    //RECOMMENDATION MODAL
    recommendationModalTitle: 'Recomendações',
    recommendationModalTab1: 'Por Atividade',
    recommendationModalTab2: 'Por Cliente',
    recommendationModalCardExternalCode: 'Código',
    recommendationModalCardBrand: 'Marca',
    recommendationModalCardStock: 'Estoque',
    recommendationModalUnitPrice: 'Preço unitário',
    recommendationModalUnitQuantity: 'Unidades',
    recommendationModalActivityEmpty: 'Sem recomendações por atividade disponíveis',
    recommendationModalClientEmpty: 'Sem recomendações por cliente disponíveis',

    //PROMOTION KIT MODAL
    promotionKitModalListTitle: 'Promoção Kit/Combo',
    promotionKitModalButtonClose: 'Fechar',
    promotionKitModalEmptyList: 'Nenhuma promoção por kit/combo encontrada!',
    promotionKitModalTotal: 'Total de promoções/kits',
    promotionKitModalFilterInput: 'Digite aqui o nome do kit/combo/cód produto/cód promoção',
    promotionKitModalButtonFetchMore: 'Carregar mais',
    promotionKitModalQuantity: 'Quantidade',
    promotionKitModalPeriod: 'Período',
    promotionKitModalLiberationDate: 'Data da liberação',
    promotionKitModalInCart: 'Kit/Combo no carrinho',

    //CLIENT SEARCH MODAL
    clientsSearchModalTitle: 'Consulta de cliente',
    clientsSearchModalSearch: 'Pesquise',
    clientsSearchModalFilterAll: 'Todos',
    clientsSearchModalNextVisit: 'Próxima visita',
    clientsSearchModalNextVisitDate: 'Próximas visitas a partir de: {date}',
    clientsSearchModalFilterNotPositive: 'Não positivado',
    clientsSearchModalFilterNotPositiveDate: 'Não positivados entre: {initialDate} - {finalDate}',
    clientsSearchModalEmptyResults: 'Resultado não encontrado',
    //RECOMMENDATION MODAL
    clientsDetailsModalTitle: 'Detalhes dos Clientes',
    clientsDetailsModalSearch: 'Pesquise',
    clientsDetailsModalFilterAll: 'Todos',
    clientsDetailsModalFilterNotPositive: 'Não positivado',
    //CLIENTS FILTER MODAL
    clientsFilterModalTitle: 'Opções de Filtro',
    clientsFilterModalTime: 'Selecione por período',
    clientsFilterModalTimeDays: 'dias',
    clientsFilterModalOr: 'Ou',
    clientsFilterModalDate: 'Selecione por data',
    clientsFilterModalDateLabel: 'A partir de',
    clientsFilterModalApply: 'Aplicar Filtro',
    clientsFilterModalvisitOnMonday: 'Segunda-feira',
    clientsFilterModalvisitOnTuesday: 'Terça-feira',
    clientsFilterModalvisitOnWednesday: 'Quarta-feira',
    clientsFilterModalvisitOnThursday: 'Quinta-feira',
    clientsFilterModalvisitOnFriday: 'Sexta-feira',
    clientsFilterModalvisitOnSaturday: 'Sábado',
    clientsFilterModalvisitOnSunday: 'Domingo',
    clientsFilterModalVisitInput: 'Dias de visita',
    clientsSearchModalFilterApplyDayFilters: 'Aplicar filtro de dias',
    //RECOMMENDATION MODAL
    clientsDetailsCardSeeMore: 'Ver detalhes',
    clientsDetailsCardGovernmentalCode: 'CPF/CNPJ',
    //ORDER MODAL
    orderModalConfirmBonificationTitle: 'Criação de pedido bonificado',
    orderModalConfirmBonificationMessage: 'Deseja criar um pedido bonificado?',
    orderModalOrderSend: 'Pedido enviado com sucesso',
    orderModalLoadingMessage: 'Aguarde...',
    orderModalMarginControlByColorDeniedMessage: 'Pedido bloqueado pelo controle de margem por cor.',
    orderModalSavingBudgetMessage: 'Salvando orçamento',
    orderModalSavingOrderMessage: 'Salvando pedido',
    orderModalCellphoneErrorMessage: 'Houve um erro ao atualizar e-mail/Telefone',
    orderModalSentOrderLinkMessage: 'O link do pagamento e o pedido foi enviado para o e-mail',
    orderModalSentLinkMessage: 'O link do pagamento já está disponível',
    orderModalOrderSafeMessage: 'Pedido salvo',
    orderModalOrderSafeBasketMessage: 'O pedido "Cesto" foi registrado, deseja realizar uma nova venda?',
    orderModalBudgetSafeMessage: 'Orçamento salvo',
    orderModalSuccessMessage: 'O {order} foi enviado para o e-mail',
    orderModalWaitingLoadMessage: 'Pedido aguardando carga',
    orderModalWaitingApprovalMessage: 'Pedido aguardando aprovação',
    orderModalSentEmailMessage: 'O pedido foi enviado para o e-mail',
    orderModalErrorSendPdfMessage: 'O pedido foi salvo, porém ocorreu um erro ao enviar o PDF para o email.',
    orderModalErrorMessage: 'Ocorreu um erro',
    orderModalLabelCopyLink: 'Copiar link',
    orderModalLabelGoto: 'Ir para {local}',
    orderModalLabelGotoNewOrder: 'Criar novo pedido',
    orderModalLabelClose: 'Fechar',

    // MODAL PROMOTION KIT
    promotionKitModalTitle: 'Promoção Kit/Combo',
    promotionKitModalValidUntil: 'Válido Até',
    promotionKitModalUnitPrice: 'Preço Unitário',
    promotionKitModalQntdInput: 'Quantidade do combo/kit',
    promotionKitModalTotalPriceInput: 'Valor Total',
    promotionKitModalProductItens: 'Itens que compõem o combo/kit',
    promotionKitModalCardUnitPrice: 'Preço Unitário',
    promotionKitModalCardTotalPrice: 'Preço total',
    promotionKitModalCardQntd: 'Qtd. combo/kit',
    promotionKitModalCardBrand: 'Marca',
    promotionKitModalAddToCart: 'Adicionar ao carrinho',
    promotionKitModalCancel: 'Cancelar',

    //ORDER MODAL DELETE
    orderModalDeleteMessage: 'Tem certeza que deseja deletar o pedido?',
    //CARD CLIENT
    clientCardCompanyText: 'Razão social',
    clientCardPhoneText: 'Telefone',
    clientCardButtonText: 'Ver detalhes',
    clientCardLastRating: 'Última avaliação: ',
    clientCardNoAvaliations: 'Sem avaliações no momento',
    clientCardMedicalCustomInfoType: 'Tipo',
    clientCardMedicalCustomInfoDocNumber: 'Documento',
    clientCardMedicalCustomInfoValidate: 'Validade',
    //WORKING HOURS
    workingHoursPlaceholderIn: 'de',
    workingHoursPlaceholderTill: 'até',
    workingHoursLabelAlter: 'Deseja configurar horário diferente do padrão?',
    workingHoursLabelForceLogoff: 'Forçar logoff no fim do dia?',
    workingHoursLabelStartFirstShift: 'Entrada Manhã',
    workingHoursLabelEndFirstShift: 'Saída Manhã',
    workingHoursLabelStartSecondShift: 'Entrada Tarde',
    workingHoursLabelStartEndSecondShift: 'Saída Tarde',
    //CONFIGURATION
    configurationTitle: 'Configuração',
    configurationSectionSystemControls: 'Controles do Sistema',
    configurationSectionSalesOrderParameters: 'Parâmetros Pedido de Venda',
    configurationSectionPDFLayout: 'Layout PDF',
    configurationSectionPDFLayoutSelect: 'ESCOLHA SEU LAYOUT DE PDF',
    configurationSectionVendorTracking: 'Cerca virtual',
    configurationSectionPayment: 'Pagamentos',
    configurationSectionProductPhotos: 'Fotos dos produtos',
    configurationSectionShipping: 'Tabela de Frete',
    configurationSectionPointsAccelerator: 'Aceleração de pontos',
    configurationSectionTradingFinancialIncrease: 'Acréscimo financeiro nas margens do motor',
    configurationSectionMarginControl: 'Controle de Margem por Valor de Pedido',
    configurationSectionMarginControlByColor: 'Controle de Margem por Cor',
    configurationSectionFactors: 'Fatores',
    configurationSectionWorkingHours: 'Horário de Trabalho',
    configurationButtonSave: 'Salvar configuração',
    configurationMessageSendImagens: 'Enviando imagens...',
    configurationMessageSuccessSendImagems: 'Imagens enviadas!',
    configurationMessageSendShipping: 'Enviando tabela de frete...',
    configurationMessageSuccessSendShipping: 'Tabela enviada!',
    configurationMessageSuccess: 'Configurações salvas!',
    configurationMessageErrorPayment: 'Preencha os dados de pagamento',
    configurationMessageErrorEmail: 'Preencha os dados do email',
    configurationMessageErrorPix: 'Preencha os dados do pix',
    configurationMessageErrorWhatsapp: 'Preencha os dados do whatsapp',
    configurationMessageErrorVendorTracking: 'Selecione apenas uma opção de cerca virtual',
    configurationMessageErrorWorkingHours: 'Preencha os dados do horário de trabalho',
    configurationMessageErrorChangeFreight: 'Selecione um valor padrão para o frete',
    configurationMessageErrorMarginControl: 'Preencha todos os dados do controle de margem',
    configurationMessageEmptyFieldsMarginControl:
      'Preencha todos os dados do controle de margem antes de adicionar um novo',
    configurationMessageErrorMarginControlBlocked:
      'Corrija os campos do intervalo de bloqueio corretamente, o valor inicial não pode ser maior que o valor final e o valor final não pode ser menor que o valor inicial',
    //CONFIGURATION-System Controls
    configurationLabelAllowCustomerRegistration: 'Permite o cadastro/edição de cliente ',
    configurationLabelAllowOrderWebRegistration: 'Permitir o lançamento de pedido na Web ',
    configurationLabelAllowUserKeepLastPayment: 'Permitir que o usuário mantenha o último pagamento do cliente',
    configurationLabelUseProfitControl: 'Utiliza controle de margem',
    configurationLabelUseOrderModule: 'Utiliza força de vendas',
    configurationLabelShowProductsMinPrice: 'Exibir switch Com Promoção',
    configurationLabelAllowShowMinPrice: 'Exibir menor preço no produto',
    configurationLabelRepeatQuantityItems: 'Manter Quantidade na Inclusão de Itens',
    configurationLabelAllowSalesTracking: 'Permite acompanhamento de venda',
    configurationLabelAllowGroupPromotions: 'Permite uso de promoções por grupo',
    configurationLabelAllowPromotionKit: 'Permite uso de promoções combo/kit',
    configurationLabelAcceptIncompleteKit: 'Aceita venda de kit de promoção combo/kit incompleto',
    configurationLabelAllowVinculatedBonification: 'Permite uso de bonificação vinculada',
    configurationLabelAllowBonificationOnPendingOrders:
      'Lista apenas pedidos aguardando aprovação quando se utiliza bonificação vinculada',
    configurationLabelMaxBonificationPercentage: 'Percentual máximo de bonificação',
    configurationLabelMaxQuantityOrderObservation: 'Qtd. de caracteres da observação do pedido',
    configurationLabelMaxQuantityDeliveryObservation: 'Qtd. de caracteres da observação da nota',
    configurationLabelExpirationBudget: 'Dias para a expiração do orçamento',
    configurationLabelClientActionCharacterLimit: 'Qtd. de caracteres da observação do cliente',
    configurationLabelAllowOrderEdit: 'Permite editar pedido',
    configurationLabelAllowOrderDelete: 'Permite deletar pedido',
    configurationLabelAllowBuyAndEarn: 'Permite compre e ganhe',
    configurationLabelUseLoadtype: 'Utiliza controle de carga fechada',
    configurationLabelUseNegotiationEngine: 'Utiliza motor de negociação',
    configurationLabelUseMedPromotions: 'Utiliza controle de medicamentos',
    configurationLabelAllowMixedBonification: 'Utiliza bonificação mista',
    configurationLabelAllowPriceUpdate: 'Aceita atualizar preços cópia/reabertura orçamento',
    configurationLabelAllowAnotherPreOrder: 'Permite incluir item com saldo pendente de venda futura',
    configurationLabelAllowAssistedSale: 'Permitir venda assistida',
    configurationLabelAcceptBlockedSale: 'Aceita venda bloqueada',
    configurationLabelAcceptDiscountDelivery: 'Aceita desconto na entrega',
    configurationLabelAcceptSaleWithoutStock: 'Aceita venda sem estoque',
    configurationLabelAcceptNegativeBalance: 'Aceita venda negativa',
    configurationLabelUseNegativeSaleWithCurrentAccountLimit: 'Valida conta-corrente mesmo em venda negativa',
    configurationLabelUsePreOrder: 'Utiliza venda futura',
    configurationLabelUseDiscountControl: 'Utiliza controle de alçada de desconto',
    configurationLabelUseSyncByChunk: 'Utiliza sync app paginado',
    configurationLabelSplitBonusOrder: 'Separar pedidos bonificados',
    configurationLabelBlockSaleWithoutPromotion: 'Bloquear inclusão de produtos sem promoção',
    configurationLabelTaxation: 'Aceita Tributação',
    useTaxByPriceTable: 'Tributação por tabela de preço',
    configurationLabelDecimals: 'Casas decimais',
    configurationLabelAppSyncInMilliseconds: 'Intervalo de tempo do sync app',
    configurationLabelMinimumOrderValue: 'Valor mínimo do pedido',
    configurationLabelBlockReason: 'Motivo do bloqueio',
    configurationLabelUseManualSearch: 'Utiliza pesquisa manual de produto',
    configurationLabelAllowVendorTracking: 'Permite o uso de Cerca Virtual Automática',
    configurationLabelAllowManualVendorTracking: 'Permite o uso de Cerca Virtual Manual',
    configurationLabelAllowCheckInOutOfLocation: 'Permite o uso de Cerca Virtual fora da localização do cliente',
    configurationLabelUsePersistentNotification: 'Utiliza notificação persistida',
    configurationLabelAllowsMultipleWithoutPackaging: 'Permitir múltiplo com embalagem',
    configurationLabelUseClientChecklist: 'Utiliza Questionário de Cliente',
    configurationLabelUseVisitControl: 'Utiliza controle de visita',
    configurationLabelUseCommercialReference: 'Utiliza referência comercial do cliente',
    configurationLabelAllowViewingNextVisitOverdue: 'Permite visualizar próximas visitas vencidas',
    configurationLabelAllowERPConfig: 'Permite configuração de ERP Sankhya',
    configurationLabelAllowIQVIA: 'Utiliza dados por IQVIA',
    configurationLabelUseFcpIcmsCredit: 'Utiliza FCP Credito ICMS',
    configurationLabelAllowAllCollectionFreightTypes:
      'Utiliza todos os tipos de frete para o tipo de pedido Retira/Collection.',
    configurationLabelShowsTotalWeightOnPDF: 'Exibir peso total no PDF',
    configurationLabelShowDiscountPDF: 'Exibir desconto no PDF',
    configurationLabelShowTabulatedPricePDF: 'Exibir preço de tabela no PDF',
    configurationLabelLocationUseApp: 'Capturar dados de localização no app?',
    configurationLabelUseSubsidiaryStockByProduct: 'Utiliza Filial de Retira por Produto',
    configurationLabelUseAccountBalanceOnBonificationOrder: 'Usa déb/créd RCA nas vendas bonificadas',
    configurationLabelSendToSankhyaPromotionCode: 'Envia código de promoção nos itens ERP Sankhya',
    configurationLabelUseBonificationType: 'Utiliza tipo de bonificação',
    configurationLabelApplyCombinedDiscount: 'Combinar % desconto tabela de preço e promoção',
    configurationLabelApplySequentialDiscountsForMinimumPrice:
      'Aplica descontos sequenciais no cálculo do preço mínimo.',
    configurationLabelUseSubsidiaryStockBy: 'Utiliza Filial de Retira no cabeçalho',
    configurationLabelSkipCreditAccountBalance: 'Não adicionar crédito no pedido',
    configurationLabelShowsFCPOnPDF: 'Exibir FCP no PDF',
    configurationLabelImportAllExternalOrders: 'Permite importar todos os pedidos externos.',
    configurationLocationOptionAllow: 'Permite',
    configurationLocationOptionDeny: 'Bloqueia',
    configurationLocationOptionPartially: 'Permite parcialmente',
    configurationDefaultPriceTableCode: 'Código da Tabela de Preço padrão',
    configurationMaxEstimatedDeliveryDate: 'Quantidade máxima de dias de previsão de entrega',
    configurationLabelDelivery: 'Transportadora',
    configurationLabelSkipInitialLoadProducts: 'Não carregar produtos automaticamente',
    configurationInfraTitle: 'Configurações de Infraestrutura',
    configurationSectionUrlSync: 'Configurações de Sync',
    configurationInfraLabelSyncHost: 'Url de Sync (Host)',
    configurationInfraLabelSyncPort: 'Porta de Sync',
    configurationInfraHostRequired: 'Host obrigatório',
    configurationInfraSubmitSuccess: 'Configurações de Infraestrutura salvas com sucesso!',
    configurationInfraNoContent: 'Nenhuma configuração de sincronização encontrada',
    configurationInfraRequiredFields: 'Preencha todos os campos obrigatórios',
    configurationExpirationDateError: 'O mínimo de dias para exipiração de orçamento é 1, definindo valor como 1.',
    configurationLabelUseCommercialRoute: 'Utiliza rota comercial',
    configurationLabelApplyMaxDiscountButton: 'Exibir botão "Aplicar Desconto Máximo"',
    configurationLabelAllowSalespersonCreateRouting: 'Permite vendedor criar Roteirização',
    configurationLabelUseUniqueCustomerCnpj: 'Utiliza CNPJ único para cliente',
    configurationLabelAddFCPSoldPriceOnPDF: 'Adiciona valor de venda com FCP em PDF',
    configurationLabelEnableAIRoutingSuggestion: 'Utiliza sugestão de roteirização por IA',
    configurationLabelEnableISAChat: 'Habilitar o IsaChat',
    configurationLabelUseSubsidiaryNamePDF: 'Utiliza nome da filial',

    // CONFIGURATION - Cerca Virtual
    configurationLabelMaxVisitTimeVendorTracking: 'Tempo de permanência máxima (minutos)',
    configurationLabelOnlyOrderOnCheckin: 'Permite venda apenas com Check-in ativo',
    configurationLabelAllowListJustification: 'Utiliza lista de justificativas pré-definidas',
    configurationLabelAutomaticCheckOutWhenPositiveOrder: 'Realizar checkout automático quando houver pedido',
    configurationLabelOnlyCheckinWithoutCheckoutPending: 'Permite Check-in apenas sem Check-out pendente',

    //CONFIGURATION-Sales Order Parameters
    configurationLabelUseBonificationSale: 'Permite venda bonificada',
    configurationLabelUseShippingControl: 'Permitir controle de frete',
    configurationLabelAllowShippingEdit: 'Permitir alterar frete manualmente',
    configurationLabelUseDefaultPaymentOption: 'Permite alterar forma de pagamento',
    configurationLabelUseDefaultPaymentPlan: 'Permite alterar plano de pagamento',
    configurationLabelAllowDiscountChanging: 'Permite incluir desconto',
    configurationLabelAllowComissionPromo: 'Permite exibir comissão',
    configurationLabelAllowInvoiceObservation: 'Permite informar observação NF',
    configurationLabelAllowProductBatch: 'Permite exibição de lotes por produto',
    configurationLabelUseClientRatingOption: 'Permite avaliar cliente',
    configurationLabelDeliveryByCityOption: 'Permite selecionar transportadoras por cidade',
    configurationLabelShippingByProviderDeliveryOption: 'Permite selecionar frete pelo fornecedor do tipo de entrega',
    configurationLabelDisableSendOrderOption: 'Desabilitar envio de pedido',
    configurationLabelResendOrderOption: 'Permite reenviar pedidos',
    configurationLabelAllowProductExpiry: 'Permitir venda por lote',
    configurationLabelBonificationApproval: 'Utiliza controle de aprovação de bonificação',
    configurationLabelBlockOrderUnratedClientOption: 'Bloquear venda para cliente sem avaliação',
    configurationLabelRequiresUpdatingDateNextVisitOption:
      'Exige atualizar data da próxima visita na avaliação do cliente.',
    configurationLabelRequiresUpdatingClientRatingDataOption:
      'Exige atualizar dados cadastrais do cliente na avaliação do cliente.',
    configurationLabelRequiresUpdatingActivityClientRatingOption:
      'Exige atualizar ramo de atividade na avaliação do cliente.',
    configurationLabelUseClientRatingControl: 'Utiliza alçada de aprovação de Avaliação do Cliente',
    configurationLabelClientRatingDeadlineOption: 'Prazo máximo de avaliação do cliente',
    configurationLabelOnlyProductOnKitOption: 'Apenas produtos do Combo/Kit',
    configurationLabelMaxLimitBalance: 'Valor mínimo de conta-corrente',
    configurationLabelMaxCreditPercentage: 'Percentual máximo acima do limite de crédito',
    configurationLabelAllowChangeFreight: 'Utilizar apenas o frete padrão',
    configurationLabelUsesProductAddOnInput: 'Utiliza complemento de produto',
    configurationLabelAllowKitOnlyOnOrder: 'Permite apenas vendas de kits',
    configurationLabelFreightSelected: 'Frete padrão',
    configurationLabelBlockEditBillingDate: 'Bloqueia alteração na data de faturamento',
    configurationLabelBlockEditOrderNumber: 'Bloqueia alteração no número do pedido',
    configurationLabelDisableRecommendationOnCart: 'Desabilita recomendações no carrinho',
    configurationLabelProductPositivationByClient: 'Positivação de produtos por Cliente',
    configurationLabelProductPositivationByVendor: 'Positivação de produtos por Vendedor',
    configurationLabelAllowOfflineProductBatch: 'Permite Lote/Vencimento de produto de forma Offline',
    configurationLabelUseFreteRapidoSystem: 'Utiliza sistema de frete rápido',
    configurationLabelUseProductTechInfoAsDescription: 'Utiliza informações técnicas do produto como descrição',
    configurationLabelHidePaymentPlanExternalCodes: 'Ocultar códigos de Planos de Pagamentos e Ordenar por Nome',
    configurationLabelUseTagFocus: 'Utiliza cadastro de Fornecedor Foco',
    configurationLabelAllowPromotionMix: 'Utiliza Promoção do tipo Mix',
    configurationLabelUseLowestAvailableDiscountPromotion:
      'Aplica automaticamente a Politica de Desconto de menor percentual disponível',
    configurationLabelAllowCanceledOrder: 'Permite cancelamento de pedido',
    configurationLabelAllowRepeatedProductOrderEdit:
      'Permite repetir produto na edição de pedido no pedido complementar',
    configurationLabelAllowRepeatedProductOrder: 'Permitir repetir produtos no pedido',
    configurationLabelUseAutomaticPricingRetailOrWholesale: 'Utilizar Precificação automática para varejo ou atacado',
    configurationLabelAllowWholesalePricingPerPackage: 'Considerar quantidade da embalagem no varejo',
    configurationLabelUsePackageQuantityInPromotionActivation:
      'Considerar quantidade da embalagem na ativação da promoção',
    configurationLabelAllowRemovePromotion: 'Permite remover promoção',
    configurationLabelAllowUserCommission: 'Permite comissão de usuário',
    configurationLabelShowTotalProductWeight: 'Mostrar peso total do produto',
    configurationLabelMinimumBatchExpiryDate: 'Data mínima de validade do lote',
    configurationLabelUseOtherExpenses: 'Utilizar input de outras despesas',
    configurationLabelAllowCoteFacil: 'Permite exportar cote facil',
    configurationLabelOrderFinalizationTimeout:
      'Aguardar finalização de pedido para bloqueio na aba de jornada do trabalho',
    configurationLabelAllowMixClientFilter: 'Permitir uso do filtro de mix do cliente',
    configurationLabelAllowSendSalesPriceWithoutRounding: 'Permitir enviar o preço de venda sem arredondamento',
    configurationLabelUseDocumentType: 'Habilitar seleção do tipo de documento fiscal',
    configurationLabelUseMandatoryMix: 'Utiliza mix obrigatório',

    //CONFIGURATION-Payment
    configurationLabelAllowPaymentLink: 'Utilizar pagamento por link',
    configurationLabelAllowPaymentPix: 'Utilizar pagamento por PIX',
    //CONFIGURATION-Api
    configurationLabelIpPrimary: 'IP Primário',
    configurationLabelIpSecondary: 'IP Secundário',
    configurationButtonTestConection: 'Testar conexão',
    configurationApiModalTitle: ' Teste de conexão',
    configurationApiModalMessage: 'Mensagem:',
    configurationApiModalMessageSuccess: 'Conectado com sucesso',
    configurationApiModalButtonRetry: 'Tentar novamente',
    configurationApiModalButtonClose: 'Fechar',
    //CONFIGURATION-Email
    configurationLabelPassword: 'Senha',
    configurationLabelPort: 'Porta SMTP',
    configurationLabelAuthentication: 'Autenticação',
    //CONFIGURATION-Trading Financial Increase
    configurationLabelInitialTime: 'Início',
    configurationLabelFinalTime: 'Fim',
    configurationLabelMarginIncrease: 'Acrécimo à margem',
    configurationButtonAddNewMargin: 'Adicionar nova margem',
    //CONFIGURATION-Margin control
    configurationLabelMarginControlInitialValue: 'Início',
    configurationLabelMarginControlFinalValue: 'Fim',
    configurationLabelMarginControlValue: 'Valor',
    configurationButtonAddNewMarginControl: 'Adicionar nova margem',

    //CONFIGURATION-Margin Control by color
    configurationLabelMarginControlByColorLabel: 'Controle de margem por cor',
    configurationLabelEnableProductMarginColorControl: 'Habilitar controle de margem por cor no produto',
    configurationLabelMarginControlByColorInitialValue: 'Início',
    configurationLabelMarginControlByColorFinalValue: 'Fim',
    configurationLabelMarginControlByColorValue: 'Valor',
    configurationLabelMarginControlByColorAction: 'Ação',
    configurationLabelMarginControlByColorColor: 'Cor',
    configurationLabelMarginControlByColorPriceTableCode: 'Tabela de preço',
    configurationButtonAddNewMarginByColorControl: 'Adicionar nova margem',

    //CONFIGURATION-Factors
    configurationLabelMinimumMargin: 'Margem mínima',
    configurationLabelMaximumSalePercentage: 'Acréscimo máximo na venda',
    configurationLabelRadiusVisit: 'Raio de visita em metros',
    configurationLabelStayLength: 'Tempo mínimo de visita em minutos',
    configurationLabelConversionFactorGift: 'Fator de pontos pedido',
    configurationLabelpointsFactorRewardValue: 'Fator de pontos recompensa',
    configurationLabelMaxNotificationRequestClientVisitFeedback: 'Qntd. de solicitações de motivo de não venda',
    configurationLabelIntervalNotificationRequestClientVisitFeedback:
      'Intervalo de solicitações para motivo de não venda',

    //CONFIGURATION-Margin control
    configurationLabelMarginControl: 'Controle de margem',

    //CUSTOMIZABLE CONTROL
    customizableControlTitle: 'Controles Customizáveis',

    // ANEXOS
    constumizableControlattachment: 'Anexos',

    //CLIENT REGISTER
    customizableControlClientRegisterTitle: 'Cadastro de Cliente',
    customizableControlAllowClientActionFieldsCustomization: 'Utiliza controle customizável de cadastro de cliente',
    customizableControlClientRegisterLabel: 'Campos obrigatórios',

    //NOTIFICATION
    notificationTitle: 'Notificação',
    notificationLabelTitle: 'Título',
    notificationLabelOrder: 'Pedido',
    notificationLabelClient: 'Cliente',
    notificationLabelShortMessage: 'Mensagem curta',
    notificationLabelShortMessageRequired: 'É obrigatório uma mensagem para poder rejeitar o pedido',
    notificationLabelSendToAll: 'Enviar para todos',
    notificationLabelUsers: 'Usuários',
    notificationButtonSubmit: 'Enviar notificação',
    notificationNewNotifications: 'Notificações novas',
    notificationShowAll: 'Mostrar todas as notificações',
    notificationLabelSend: 'Enviar',
    notificationLabelList: 'Lista',

    //TENANT
    tenantFormTitle: 'Empresa',
    tenantFormPriceTableCode: 'Tabela de Preço',
    tenantFormPriceTableCodeSaving: 'Salvando tabela de preço',
    tenantFormPriceTableCodeSaveSuccess: 'Tabela de preço editada com sucesso.',
    tenantFormSendImage: 'Enviando imagem da empresa, aguarde....',
    tenantTestConnectionAlert: 'Testando Conexão...',
    tenantTestConnectionAlertSuccess: 'Conexão feita com sucesso!',
    tenantFormSubsidiarySendImage: 'Enviando imagem da filial, aguarde....',
    tenantErpModalTitle: 'Configuração de Sankhya ERP',
    tenantErpModalAddNewButton: 'Adicionar nova configuração',
    tenantErpModalRemoveButton: 'Remover configuração',
    tenantErpModalRemoveLastButton: 'Remover última configuração',
    tenantErpRegisterModalTitle: 'Cadastro de configuração de ERP',
    tenantErpRegisterConfigurationTitle: 'Configuração {index}',
    tenantErpRegisterTypeOperation: 'Tipo de operação',
    tenantErpRegisterTypeSales: 'Tipo de vendas',
    tenantErpRegisterSubsidiary: 'Código da filial',
    tenantErpRegisterTypeMovi: 'Tipo Movi',
    tenantErpRegisterIsPrice: 'Preço',
    tenantErpRegisterOriginCode: 'Código de origem',
    tenantErpRegisterCencusCode: 'Código Cencus',
    tenantErpRegisterCodeNat: 'Código Nat',
    tenantErpRegisterCreatedAt: 'Criado em',
    tenantErpRegisterSaveButton: 'Salvar',
    tenantErpRegisterHasUndefinedField: 'Existem campos não preenchidos',
    tenantErpRegisterFillAllFields: 'Preencha todos os campos para adicionar uma nova configuração',
    tenantErpRegisterSuccessMessage: 'Configuração(ões) salva(s) com sucesso',
    tenantErpRegisterEditMessage: 'Configuração(ões) editada(s) com sucesso',
    tenantErpModalDeleteSuccessMessage: 'Configuração excluída com sucesso',
    tenantErpModalEmptyItens: 'Nenhuma configuração encontrada',
    tenantErpModalDeleteTitle: 'Excluir configuração',
    tenantErpModalDeleteMessage: 'Tem certeza que deseja excluir a configuração?',
    tenantErpModalDeleteConfirm: 'Deletar',
    tenantErpModalDeleteCancel: 'Cancelar',

    tenantUrlModalTitle: "Configuração de URL's",
    tenantUrlModalUrlBase: 'URL Principal',
    tenantUrlModalUrlSecondary: 'URL Secundária',
    tenantUrlModalSwapUrls: 'Trocar URL principal',
    tenantUrlModalSendSuccess: 'URL salva com sucesso',

    //PROMOTION
    promotionListTitle: 'Promoções',
    promotionListButtonAdd: 'Nova promoção',
    //PROMOTION-FORM
    promotionFormTitle: 'Cadastro de promoção',
    promotionFormButtonEdit: 'Atualizar promoção',
    promotionFormButtonNew: 'Criar promoção',
    promotionFormLabelPromotionName: 'Nome da promoção',
    promotionFormLabelExternalCode: 'Código do ERP',
    promotionFormLabelStarDate: 'Data início',
    promotionFormLabelDateTo: 'até',
    promotionFormLabelEndDate: 'Data fim',
    promotionFormLabelReleaseDate: 'Data liberação',
    promotionFormLabelInstantApplyDiscount: 'Aplicar desconto automaticamente?',
    promotionFormLabelTypeBalance: 'Caso utilize conta corrente',
    promotionFormLabelCreditBalance: 'Balanço de crédito',
    promotionFormLabelDebitBalance: 'Balanço de débito',
    promotionFormLabelIsPromotionKit: 'Promoção Kit',
    promotionFormLabelRequireAdditionalProductToKit: 'Requer produto adicional para o kit',
    promotionFormLabelIsPromotionMix: 'Promoção Mix',
    promotionFormLabelMinimumPromotionValue: 'Valor mínimo da promoção',
    promotionFormLabelCreateTitle: 'Adicionar um item',
    promotionFormLabelClient: 'Cliente',
    promotionFormLabelClientGroup: 'Grupo de cliente',
    promotionFormLabelPriceTable: 'Tabela de preço',
    promotionFormLabelSubsidiary: 'Filial',
    promotionFormLabelActivity: 'Ramo de atividade',
    promotionFormLabelPaymentOption: 'Cobrança',
    promotionFormLabelPaymentPlan: 'Pagamento',
    promotionFormLabelVendor: 'Vendedor',
    promotionFormLabelSupervisor: 'Supervisor',
    promotionFormLabelIncludeFinancialPercentage: 'Incluir ao custo do produto perc. plano de pagamento',
    promotionFormLabelFinancialCost: 'Custo do produto',
    promotionFormLabelInitialQuantity: 'Quantidade Inicial',
    promotionFormLabelFinalQuantity: 'Quantidade Final',
    promotionFormLabelQuantityKit: 'Quantidade Combo/kit',
    promotionFormLabelFixedPrice: 'Preço Fixo',
    promotionFormLabelDiscountPercentage: 'Percentual de Desconto',
    promotionFormLabelComissionPromo: 'Comissão',
    promotionFormLabelRequired: 'Produtos obrigátorios',
    promotionFormLabelBonification: 'Bonificação',
    promotionFormLabelReward: 'Brinde/Recompensa',
    promotionFormLabelPromotionMix: 'Promoção Mix',
    promotionFormLabelImageKit: 'Imagem do Kit',
    promotionFormLabelType: 'Tipo',
    promotionFormLabelLoadType: 'Tipo de carga',
    promotionFormNoOptions: 'Nenhum registros encontrados',
    promotionFormAutocompleteLoading: 'Carregando...',
    promotionFormCreatedSuccess: 'Promoção criado com sucesso!',
    promotionFormUpdatedSuccess: 'Promoção editado com sucesso!',
    promotionFormExcludeSuccess: 'Promoção excluído com sucesso',
    promotionMessageRequiredExternalCode: 'Código do ERP é obrigatório',
    promotionMessageRequiredPromotionName: 'Nome da promoção é obrigatório',
    promotionMessageRequiredItems: 'Nenhum item informado, adicionar ao menos um item de promoção',
    promotionMessageRangeInvalid: 'Data da promoção está inválida ou incompleta',
    promotionFormButtonAdded: 'Adicionar item',
    promotionFormButtonUpdated: 'Atualizar item',
    promotionFormDescription: 'Descrição',
    promotionFormRequiredPoints: 'Pts. requiridos',

    //LOADTYPE-LIST
    loadTypeListTitle: 'Tipos de carga',
    loadTypeListButtonAdd: 'Novo tipo de carga',
    loadTypeListTableHeaderId: 'ID',
    loadTypeListTableHeaderName: 'Nome',
    loadTypeListTableHeaderCode: 'Código',
    loadTypeListTableHeaderCreatedAt: 'Dt. criação',
    loadTypeListTableHeaderUpdatedAt: 'Dt. atualização',
    //LOADTYPE-FORM
    loadTypeFormTitle: 'Cadastro de tipo de carga',
    loadTypeFormButtonEdit: 'Atualizar tipo de carga',
    loadTypeFormButtonNew: 'Criar tipo de carga',
    loadTypeFormLabelCode: 'Código',
    loadTypeFormLabelName: 'Descrição da modalidade',
    loadTypeFormLabelDeliveryType: 'Tipo de frete',
    loadTypeFormLabelMaximumDeliveryQuantity: 'Quantidade máxima de entrega ',
    loadTypeFormLabelMinimumWeightDelivery: 'Peso mínimo por entrega (em KG) ',
    loadTypeFormLabelMinimumWeightLoad: 'Peso mínimo da modalidade (em KG) ',
    loadTypeFormLabelMaximumWeightLoad: 'Peso máximo da modalidade (em KG)',
    loadTypeFormLabelInactive: 'Inativo',
    loadTypeFormMessageRequiredExternalCode: 'Código é obrigatório',
    loadTypeFormMessageRequiredName: 'Nome é obrigatório',
    loadTypeFormCreatedMessage: 'Tipo de carga criado com sucesso!',
    loadTypeFormUpdatedMessage: 'Tipo de carga editado com sucesso!',
    loadTypeFormExcludeMessage: 'Tipo de carga excluído com sucesso',
    //LOADCONTROL-LIST
    loadControlListTitle: 'Controles de carga',
    loadControlListButtonAdd: 'Novo controle de carga',
    loadControlListTableHeaderId: 'ID',
    loadControlListTableHeaderName: 'Nome',
    loadControlListTableHeaderCode: 'Código',
    loadControlListLabelLoadType: 'Tipo de carga',
    loadControlListLabelVendors: 'Vendedores associados',
    loadControlListLabelOrders: 'Pedidos',
    loadControlListLabelTotalDeliveries: 'Total de entregas',
    loadControlListLabelTotalValue: 'Total em Valor (R$)',
    loadControlListLabelTotalWeight: 'Total em Peso (KG)',
    loadControlListTableHeaderCreatedAt: 'Dt. criação',
    loadControlListTableHeaderUpdatedAt: 'Dt. atualização',
    //LOADCONTROL-FORM
    loadControlFormTitle: 'Cadastro de controle de carga',
    loadControlFormButtonSave: 'Salvar carga',
    loadControlFormButtonCancel: 'Cancelar carga',
    loadControlFormButtonNew: 'Criar controle de carga',
    loadControlFormLabelCode: 'Código',
    loadControlFormLabelName: 'Nome',
    loadControlFormLabelLoadType: 'Tipo de carga',
    loadControlFormLabelVendors: 'Vendedores associados',
    loadControlFormLabelOrders: 'Pedidos',
    loadControlFormLabelTotalDeliveries: 'Total de entregas',
    loadControlFormLabelTotalValue: 'Total em Valor (R$)',
    loadControlFormLabelTotalWeight: 'Total em Peso (KG)',
    loadControlFormMessageRequiredName: 'Nome é obrigatório',
    loadControlFormClose: 'Deseja fechar a carga e enviar os pedidos?',
    loadControlFormCloseButton: 'Fechar Carga',
    loadControlFormCloseSuccess: 'Controle de carga fechado com sucesso!',
    loadControlFormSafeSuccess: 'Controle de carga salvo com sucesso!',
    loadControlFormCreatedSuccess: 'Controle de carga criado com sucesso!',
    loadControlFormExclude: 'Deseja cancelar a carga? Todos os pedidos serão devinculados.',
    loadControlFormCancelSuccess: 'Controle de carga cancelado com sucesso!',
    loadControlFormExcludeSuccess: 'Controle de carga excluído com sucesso!',
    //ACCESSPROFILE-LIST
    acessProfileListTitle: 'Perfis de acesso',
    acessProfileListButtonAdd: 'Novo perfil de acesso',
    acessProfileListTableHeaderCode: 'Código',
    acessProfileListTableHeaderName: 'Nome',
    acessProfileListTableHeaderCreatedAt: 'Dt. criação',
    acessProfileListTableHeaderUpdatedAt: 'Dt. atualização',
    //ACCESSPROFILE-FORM
    accessProfileFormTitle: 'Cadastro de perfil de acesso',
    accessProfileFormButtonEdit: 'Atualizar perfil de acesso',
    accessProfileFormButtonNew: 'Criar perfil de acesso',
    accessProfileFormLabelName: 'Nome',
    accessProfileFormLabelPermitionType: 'Tipo de permissão',
    accessProfileFormMessageRequiredName: 'Nome do perfil é obrigatório',
    //ACCESSPROFILE-SECTIONS
    accessLabelDashboard: 'Dashboard',
    accessLabelNotification: 'Notificação',
    accessLabelConfiguration: 'Configuração',
    accessLabelOrder: 'Pedido',
    accessLabelListOrder: 'Listar pedidos',
    accessLabelViewOrder: 'Visualizar pedidos',
    accessLabelRewards: 'Recompensa',
    accessLabelListRewards: 'Listar recompensas',
    accessLabelNewRewards: 'Criar recompensa',
    accessLabelEditRewards: 'Editar recompensa',
    accessLabelDeleteRewards: 'Deletar recompensa',
    accessLabelTrading: 'Motor de Negociação',
    accessLabelListTrading: 'Listar recompensas',
    accessLabelNewTrading: 'Criar motor de negociação',
    accessLabelEditTrading: 'Editar motor de negociação',
    accessLabelDeleteTrading: 'Deletar motor de negociação',
    accessLabelSponsored: 'Patrocinados',
    accessLabelListSponsored: 'Listar patrocinados',
    accessLabelNewSponsored: 'Criar patrocinado',
    accessLabelEditSponsored: 'Editar patrocinado',
    accessLabelDeleteSponsored: 'Deletar patrocinado',
    accessLabelPromotion: 'Promoção',
    accessLabelListPromotion: 'Listar promoções',
    accessLabelNewPromotion: 'Criar promoção',
    accessLabelEditPromotion: 'Editar promoção',
    accessLabelDeletePromotion: 'Deletar promoção',
    accessLabelLoadType: 'Tipo de carga',
    accessLabelListLoadType: 'Listar  tipos de carga',
    accessLabelNewLoadType: 'Criar tipo de carga',
    accessLabelEditLoadType: 'Editar tipo de carga',
    accessLabelDeleteLoadType: 'Deletar tipo de carga',
    accessLabelAccessProfile: 'Perfil de acesso',
    accessLabelListAccessProfile: 'Listar  perfis de acesso',
    accessLabelNewAccessProfile: 'Criar perfil de acesso',
    accessLabelEditAccessProfile: 'Editar perfil de acesso',
    accessLabelDeleteAccessProfile: 'Deletar perfil de acesso',

    accessLabelTeam: 'Time',
    accessLabelListTeam: 'Listar times',
    accessLabelNewTeam: 'Criar time',
    accessLabelEditTeam: 'Editar time',
    accessLabelDeleteTeam: 'Deletar time',
    accessLabelUpdateWorkingHoursTeam: 'Alterar horário de trabalho',
    accessLabelLinkSalesConstraintTeam: 'Vincular restrição de venda',

    accessLabelUser: 'Usuário',
    accessLabelListUser: 'Listar usuários',
    accessLabelNewUser: 'Criar usuário',
    accessLabelEditUser: 'Editar usuário',
    accessLabelDeleteUser: 'Deletar usuário',
    accessLabelUpdateDeviceListUser: 'Listar/editar lista de dispositivos',
    accessLabelLinkSalesConstraintUser: 'Vincular restrição de venda',

    //CLIENT-LIST
    clientListTitle: 'Cliente',
    clientListButtonAdd: 'Novo cliente',
    clientListTableHeaderCode: 'Código',
    clientListTableHeaderName: 'Nome',
    clientListTableHeaderCorporateName: 'Razão Social',
    clientListTableHeaderGovernmentalCode: 'CPF/CNPJ',
    clientListTableHeaderBlocked: 'Bloqueado?',
    clientListTableHeaderLastPurchase: 'Dt. última compra',
    clientListTableHeaderCreatedAt: 'Dt. criação',
    clientListTableHeaderUpdatedAt: 'Dt. atualização',
    clientListTableHeaderStatus: 'Status',
    clientListTableHeaderErrorLog: 'Motivo',

    //CLIENT-LIST
    clientListWalletNotFound: 'Carteira não encontrada',

    //CLIENT-LIST-CARD
    clientListCardGovernmentalCode: 'CPF/CNPJ',
    clientListCardNextVisit: 'Próxima visita',
    clientListCard: 'Próxima visita',
    clientListSeeMore: 'Ver detalhes',
    clientListCardNoAvaliations: 'Sem avaliações no momento',

    //CLIENT-FORM
    clientFormTitle: 'Cadastro de cliente',
    clientFormButtonEdit: 'Atualizar cliente',
    clientFormButtonNew: 'Criar cliente',
    clientFormClientType: 'Tipo de Cliente',
    clientFormLabelLegalPerson: 'Pessoa Jurídica',
    clientFormLabelPhysicalPerson: 'Pessoa Física',
    clientFormLabelExternalCode: 'Código do Cliente',
    clientFormLabelCPFCNPJ: 'CPF/CNPJ',
    clientFormLabelName: 'Nome',
    clientFormLabelSurname: 'Apelido',
    clientFormLabelNameCNPJ: 'Nome Fantasia',
    clientFormLabelClientNameCNPJ: 'Razão Social',
    clientFormLabelEmail: 'Email',
    clientFormLabelInvoiceEmail: 'Email NFe',
    clientFormLabelBillingEmail: 'Email de cobrança',
    clientFormLabelGovernmentalCode: 'CNPJ/CPF',
    clientFormLabelGovernmentalCodeInvalid: 'CPF/CNPJ Inválido',
    clientFormLabelCnpjAlreadyInOwnWallet: 'Cliente já cadastrado em sua carteira',
    clientFormLabelCnpjAlreadyInWallet: 'Cliente já cadastrado na carteira do(s) vendedor(es): {wallets}.',
    clientFormLabelCnpjAlreadyInWalletLastPurchase: 'Última compra em feita em {date} há {days} dia(s).',
    clientFormLabelCnpjAlreadyInWalletWithoutLastPurchase: 'Data não informada',
    clientFormLabelCnpjAlreadyInWalletWithoutVendor: 'Cliente já cadastrado porém sem vendedor (Wallet)',
    clientFormLabelExternalServiceUnavailable: 'Serviço externo indisponível no momento.',
    clientFormLabelServiceUnavailable: 'Serviço indisponível no momento.',
    clientFormLabelSimpleNational: 'Optante Simples Nacional?',
    clientFormLabelCustomerUsesSourceST: 'Cliente Utiliza ST Fonte?',
    clientFormLabelTaxpayer: 'Contribuinte?',
    clientFormLabelFinalConsumer: 'Consumidor Final?',
    clientFormLabelSubsidizedSale: 'Venda Bonificada?',
    clientFormLabelStateRegistration: 'Inscrição Estadual',
    clientFormLabelCustomerBirthDate: 'Data de Nascimento',
    clientFormLabelPotential: 'Potencial de Vendas',
    clientFormLabelFirstPurchaseDate: 'Data da Primeira Compra',
    clientFormLabelLastPurchaseDate: 'Data da Ultima Compra',
    clientFormLabelBlocked: 'Bloqueado?	',
    clientFormLabelBlockedDate: 'Data de bloqueio',
    clientFormLabelCreditLimit: 'Limite de Crédito	',
    clientFormLabelActivity: 'Ramo de Atividade	',
    clientFormLabelPaymentOption: 'Cobrança',
    clientFormLabelPaymentPlan: 'Plano de Pagamento',
    clientFormLabelSquare: 'Praça',
    clientFormLabelSubsidiaries: 'Filiais',
    clientFormLabelBlockReason: 'Motivo bloqueio',
    clientFormLabelClientGroup: 'Grupo de Clientes',
    clientFormLabelObservation: 'Observação',
    clientFormLabelObservation2: 'Observação 2',
    clientFormLabelObservation3: 'Observação 3',
    clientFormLabelDayOfVisit: 'Dia da visita',
    clientFormLabelProductExpiry: 'Expiração do Produto (em dias)',
    clientFormLabelAvailableCredit: 'Credito disponivel	',
    clientFormLabelOpenBills: 'Contas abertas',
    clientFormLabelCredit: 'Crédito',
    clientFormLabelLocation: 'Informações de Geolocalização do cliente',
    clientFormLabelPriceTableCode: 'Código da Tabela de Preço do Cliente',
    clientFormLabelCommercialInfo: 'Informações comerciais do cliente',
    clientFormLabelCommercialInfoPostalCode: 'CEP',
    clientFormLabelCommercialInfoAddress: 'Endereço',
    clientFormLabelCommercialInfoNumber: 'Número',
    clientFormLabelCommercialInfoDistrict: 'Bairro',
    clientFormLabelCommercialInfoCity: 'Cidade',
    clientFormLabelCommercialInfoState: 'Estado',
    clientFormLabelCommercialInfoPhoneNumber: 'Telefone',
    clientFormLabelCommercialInfoCellphoneNumber: 'Celular',
    clientFormLabelDeliveryInfo: 'Informações entrega do cliente	',
    clientFormLabelDeliveryInfoPostalCode: 'CEP',
    clientFormLabelDeliveryInfoAddress: 'Endereço',
    clientFormLabelDeliveryInfoNumber: 'Número',
    clientFormLabelDeliveryInfoDistrict: 'Bairro',
    clientFormLabelDeliveryInfoCity: 'Cidade',
    clientFormLabelDeliveryInfoState: 'Estado',
    clientFormLabelDeliveryInfoPhoneNumber: 'Celular',
    clientFormLabelRegulatoryTitle: 'Órgão Regulador',
    clientFormLabelRegulatoryInfoState: 'Estado',
    clientFormLabelRegulatoryResposible: 'Responsável',
    clientFormLabelBillingInfo: 'Informações cobrança do cliente	',
    clientFormLabelBillingInfoPostalCode: 'CEP',
    clientFormLabelBillingInfoAddress: 'Endereço',
    clientFormLabelBillingInfoNumber: 'Número',
    clientFormLabelBillingInfoDistrict: 'Bairro',
    clientFormLabelBillingInfoCity: 'Cidade',
    clientFormLabelBillingInfoState: 'Estado',
    clientFormLabelBillingInfoPhoneNumber: 'Celular',
    clientFormLabelViabilityInfo: 'Informações de viabilidade do cliente',
    clientFormLabelViabilityBuyerName: 'Nome do Comprador',
    clientFormLabelViabilityInfoContact: 'Contato do Comprador',
    clientFormLabelViabilityInfoDeadlineSuggestion: 'Sugestão de Prazo',
    clientFormLabelViabilityInfoCreditLimitSuggestion: 'Sugestão de Limite de Crédito',
    clientFormLabelDocumentInfo: 'Informações de Documentos do cliente',
    clientFormLabelDocumentInfoDocument: 'Documentos',
    clientFormLabelDocumentInfoOldDocuments: 'Documentos já cadastrados',

    clientFormInvalidFields: 'Alguns campos não foram preenchidos!',
    clientFormCreatedMessage: 'Cliente criado com sucesso!',
    clientFormUpdatedMessage: 'Cliente editado com sucesso!',
    clientFormLabelInvalidCEP: 'CEP inválido',

    clientRatingForm: 'Avaliação',
    clientRatingFormComment: 'Comentário',
    clientRatingFormVisited: 'Visitado?',
    clientRatingFormDateNextVisit: 'Data da próxima visita',
    clientRatingFormEmail: 'Email',
    clientRatingFormCellphone: 'Celular',
    clientRatingFormTelephone: 'Telefone',
    clientRatingFormActivity: 'Ramo de Atividade',
    clientRatingFormCommentRequired: 'Comentário é obrigatório.',
    clientRatingFormDateRequired: 'Data é obrigatória.',
    clientRatingFormVisitedRequired: 'Visita é obrigatório.',
    clientRatingFormEmailInvalid: 'Email inválido.',
    clientRatingFormEmailRequired: 'Email é obrigatório.',
    clientRatingFormCellphoneRequired: 'Celular é obrigatório.',
    clientRatingFormTelephoneRequired: 'Telefone é obrigatório.',
    clientRatingFormActivityRequired: 'Ramo de Atividade é obrigatório.',
    clientRatingFormEmpty: 'Cliente não possui avaliações no momento.',
    clientRatingFormCreatedMessage: 'Avaliação criada com sucesso.',

    clientPhotoFormEmpty: 'Nenhuma foto cadastrada',
    clientPhotoFormButtonSave: 'Salvar fotos',
    clientPhotoFormPrevious: 'Prévia',
    clientPhotoFormCoverImage: 'Capa?',
    clientPhotoFormSaveImageMessage: 'Fotos salvas com sucesso!',
    clientPhotoFormEditImageMessage: 'Foto editada com sucesso!',
    clientPhotoFormDeleteImageMessage: 'Foto deletada com sucesso!',

    clientRatingControlTabMessage1: 'Houve uma modificação de dados do cliente vindos de uma avaliação.',
    clientRatingControlTabMessage2:
      'Por favor verifique se irá aceitar ou recusar a alteração das informações enviadas.',
    clientRatingControlTabMessageEmpty: 'Nenhuma avaliação encontrada',
    clientRatingControlTabMessageActivity: 'Ramo de atividade',
    clientRatingControlTabMessageEmail: 'Email',
    clientRatingControlTabMessageCellPhoneNumber: 'Número de celular',
    clientRatingControlTabMessagePhoneNumber: 'Número de telefone',
    clientRatingControlTabMessageAccept: 'Avaliação aceita com sucesso!',
    clientRatingControlTabMessageReject: 'Avaliação rejeitada com sucesso!',

    //Validations
    clientFormMessageRequiredClientName: 'Nome/Razão Social é obrigatório',
    clientFormMessageRequiredName: 'Apelido/Nome Fantasia é obrigatório',
    clientFormMessageRequiredGovernmentalCode: 'CNPJ/CPF é obrigatório',
    clientFormMessageInvalidEmail: 'Email inválido',
    clientFormMessageInvalidInvoiceEmail: 'Email NFE inválido',
    clientFormMessageInvalidBillingEmail: 'Email de cobrança inválido',
    clientFormMessageRequiredEmail: 'Email é obrigatório',
    clientFormMessageRequiredEmailNfe: 'Email NFe é obrigatório',
    clientFormMessageRequiredStateRegistration: 'Inscrição estadual é obrigatório',
    clientFormMessageRequiredStateSquare: 'Praça é obrigatório',
    clientFormMessageRequiredStateActivity: 'Ramo de Atividade é obrigatório',

    clientFormMessageRequiredCommercialInfoPostalCode: 'Informações Comerciais - CEP é obrigatório',
    clientFormMessageRequiredCommercialInfoAddress: 'Informações Comerciais - Endereço é obrigatório',
    clientFormMessageRequiredCommercialInfoNumber: 'Informações Comerciais - Número é obrigatório',
    clientFormMessageRequiredCommercialInfoDistrict: 'Informações Comerciais - Bairro é obrigatório',
    clientFormMessageRequiredCommercialInfoCity: 'Informações Comerciais - Cidade é obrigatório',
    clientFormMessageRequiredCommercialInfoState: 'Informações Comerciais - Estado é obrigatório',
    clientFormMessageRequiredCommercialInfoPhoneNumber: 'Informações Comerciais - Telefone é obrigatório',
    clientFormMessageRequiredCommercialInfoCellphoneNumber: 'Informações Comerciais - Celular é obrigatório',

    clientFormMessageRequiredDeliveryInfoPostalCode: 'Informações de Entrega - CEP é obrigatório',
    clientFormMessageRequiredDeliveryInfoAddress: 'Informações de Entrega - Endereço é obrigatório',
    clientFormMessageRequiredDeliveryInfoNumber: 'Informações de Entrega - Número é obrigatório',
    clientFormMessageRequiredDeliveryInfoDistrict: 'Informações de Entrega - Bairro é obrigatório',
    clientFormMessageRequiredDeliveryInfoCity: 'Informações de Entrega - Cidade é obrigatório',
    clientFormMessageRequiredDeliveryInfoState: 'Informações de Entrega - Estado é obrigatório',
    clientFormMessageRequiredDeliveryInfoPhoneNumber: 'Informações de Entrega - Telefone é obrigatório',

    clientFormMessageRequiredBillingInfoPostalCode: 'Informações de Cobrança - CEP é obrigatório',
    clientFormMessageRequiredBillingInfoAddress: 'Informações de Cobrança - Endereço é obrigatório',
    clientFormMessageRequiredBillingInfoNumber: 'Informações de Cobrança - Número é obrigatório',
    clientFormMessageRequiredBillingInfoDistrict: 'Informações de Cobrança - Bairro é obrigatório',
    clientFormMessageRequiredBillingInfoCity: 'Informações de Cobrança - Cidade é obrigatório',
    clientFormMessageRequiredBillingInfoState: 'Informações de Cobrança - Estado é obrigatório',
    clientFormMessageRequiredBillingInfoPhoneNumber: 'Informações de Cobrança - Telefone é obrigatório',
    clientFormMessageRequiredFinalConsumer: 'O campo Consumidor final é obrigatório',
    clientFormMessageRequiredTaxpayer: 'O campo Contribuinte é obrigatório',

    //REASON-LIST
    reasonListTitle: 'Motivos',
    reasonListButtonAdd: 'Novo motivo',
    reasonListTableHeaderId: 'ID',
    reasonListTableHeaderCode: 'Código',
    reasonListTabbleHeaderActions: 'Ação',
    reasonListTabbleHeaderType: 'Tipo',
    reasonListTableHeaderDescription: 'Descrição',
    reasonListTableHeaderCreatedAt: 'Dt. criação',
    reasonListTableHeaderUpdatedAt: 'Dt. atualização',
    //REASON-FORM
    reasonFormTitle: 'Cadastro de motivo',
    reasonFormButtonEdit: 'Atualizar motivo',
    reasonFormButtonNew: 'Criar motivo',
    reasonFormLabelCode: 'Código',
    reasonFormLabelExternalCode: 'Código externo',
    reasonFormLabelDescription: 'Descrição',
    reasonFormLabelAllowToken: 'Utilizar senha para desbloqueio?',
    reasonFormLabelToken: 'Senha para desbloqueio',
    reasonFormLabelSubsidiary: 'Filiais',
    reasonFormLabelType: 'Tipo/Categoria',
    reasonFormLabelOriginSubsidiary: 'Filial de origem',
    reasonFormLabelFinalSubsidiary: 'Filial de destino',
    reasonFormMessageRequiredExternalCode: 'Código externo é obrigatório',
    reasonFormMessageRequiredDescription: 'Descrição é obrigatório',
    reasonFormMessageRequiredToken: 'Senha para desbloqueio é obrigatório',
    reasonFormMessageRequiredVendors: 'Vendedores são obrigatórios',
    reasonFormCreatedSuccess: 'Motivo criado com sucesso',
    reasonFormUpdatedSuccess: 'Motivo atualizado com sucesso',
    reasonFormExcludeSuccess: 'Motivo excluído com sucesso',

    //ORDER-SPLIT LIST
    orderSplitListTitle: 'Divisão de pedidos',
    orderSplitListButtonAdd: 'Nova divisão',
    orderSplitListTableOriginSubsidiary: 'Filial de origem',
    orderSplitListTableFinalSubsidiary: 'Filial de destino',
    orderSplitListTableHeaderCreatedAt: 'Dt. criação',
    orderSplitListTableHeaderUpdatedAt: 'Dt. atualização',

    //ORDER-SPLIT FORM
    orderSplitFormTitle: 'Cadastro de divisão',
    orderSplitFormOriginSubsidiary: 'Filial de origem',
    orderSplitFormFinalSubsidiary: 'Filial de destino',
    orderSplitFormProduct: 'Produtos',
    orderSplitFormBrand: 'Marca',
    orderSplitFormCategory: 'Categoria',
    orderSplitFormDepartment: 'Departamento',
    orderSplitFormSection: 'Seção',
    orderSplitFormProductLine: 'Linha de produto',
    orderSplitFormOriginSubsidiaryRequired: 'Filial de origem é obrigatório',
    orderSplitFormFinalSubsidiaryRequired: 'Filial de destino é obrigatório',
    orderSplitFormSectionRequired: 'Seção é obrigatório',

    orderSplitFormCreatedSuccess: 'Divisão de pedidos criado com sucesso',
    orderSplitFormUpdatedSuccess: 'Divisão de pedidos atualizado com sucesso',
    orderSplitFormExcludeSuccess: 'Divisão de pedidos excluído com sucesso',

    //CHECKLIST CLIENT LIST
    checklistClientListTitle: 'Questionário de clientes',
    checklistClientListButtonAdd: 'Novo questionário',
    checklistClientListTableHeaderVendor: 'Cadastrado por',
    checklistClientListTableHeaderQuestionaryName: 'Nome do questionário',
    checklistClientListTableHeaderTypeQuestion: 'Obrigatório?',
    checklistClientListTableHeaderCreatedAt: 'Criado em',
    checklistClientListTableHeaderUpdatedAt: 'Atualizado em',
    checklistClientListItemQuestionTypeText: 'Caixa de Texto',
    checklistClientListItemQuestionTypeRadio: 'Única Alternativa',
    checklistClientListItemDetailsQuestion: 'Detalhes da questão',
    checklistClientModalTitle: 'Detalhes do questionário',
    checklistClientModalQuestionaryName: 'Nome do questionário',
    checklistClientModalQuestionaryClientType: 'Tipo de cliente',
    checklistClientModalQuestionaryRequired: 'Questionário obrigatório para esse tipo de cliente?',
    checklistClientModalQuestion: 'Pergunta',
    checklistClientModalClose: 'Fechar',
    checklistClientModalTypeQuestion: 'Tipo de resposta',
    checklistClientModalAlternatives: 'Alternativas',
    checklistClientModalPhotoRequired: 'Enviar foto?',
    checklistClientModalAnswers: 'Respostas',
    checklistClientModalTableHeadUser: 'Usuário',
    checklistClientModalTableHeadClient: 'Cód. Cliente',
    checklistClientModalTableHeadQuestion: 'Pergunta',
    checklistClientModalTableHeadResponse: 'Resposta',

    //CHECKLIST CLIENT FORM
    checklistClientFormTitle: 'Cadastro de Questionário',
    checklistClientFormLabelName: 'Nome do questionário',
    checklistClientFormLabelClientType: 'Tipo de cliente',
    checklistClientFormLabelRequired: 'Questionário obrigatório para esse tipo de cliente?',
    checklistClientFormLabelTitle: 'Pergunta {index}',
    checklistClientFormLabelQuestion: 'Pergunta',
    checklistClientFormLabelTypeAnswer: 'Tipo de resposta',
    checklistClientFormTypeAnswerInputTextOption: 'Caixa de texto',
    checklistClientFormTypeAnswerRadioOption: 'Única Alternativa',
    checklistClientFormLabelPhotoRequired: 'Enviar foto?',
    checklistClientFormLabelOptionsAnswerLabel: 'Opções de respostas',
    checklistClientFormLabelOptionsAnswer: 'Resposta {index}',
    checklistClientFormLabelOptionsAnswerAdd: 'Adicionar nova resposta',
    checklistClientFormButtonEdit: 'Atualizar questionário',
    checklistClientFormButtonNew: 'Criar questionário',
    checklistClientFormQuestionaryNameRequired: 'Nome do questionário é obrigatório',
    checklistClientFormQuestionaryNameMin: 'Nome do questionário deve ter ao menos 3 caracteres',
    checklistClientFormQuestionRequired: 'Pergunta é obrigatória',
    checklistClientFormTypeAnswerRequired: 'Tipo de resposta é obrigatória',
    checklistClientFormOptionsAnswerRequired: 'Resposta é obrigatória',
    checklistClientFormOptionsMinAnswerRequired: 'Ao menos duas opções de resposta são obrigatórias',
    checklistClientExcludeDeleteMessage:
      'Atenção: Esse questionário pode ter sido utilizado, deseja realmente excluí-lo?',
    checklistClientCreatedSuccess: 'Questionário criado com sucesso!',
    checklistClientUpdatedSuccess: 'Questionário editado com sucesso!',
    checklistClientExcludeSuccess: 'Questionário excluído com sucesso!',

    //PRODUCT PHOTOS
    productsPhotosTitle: 'Fotos dos Produtos',
    productsPhotosListButtonAdd: 'Multiplos produtos',
    productsPhotosFilterButton: 'Filtros',
    productsPhotosFilterTitle: 'Filtros',
    productsPhotosFilterApply: 'Aplicar Filtros',

    productsPhotosFilterBrands: 'Marcas',
    productsPhotosFilterDescription: 'Nome do produto',
    productsPhotosFilterCategory: 'Categorias',
    productsPhotosFilterDepartments: 'Departamentos',
    productsPhotosFilterProviders: 'Fornecedores',
    productsPhotosFilterSections: 'Seções',
    productsPhotosFilterProducLine: 'Linha de Produtos',

    productsPhotosListTableHeaderPicture: 'Foto do Produto',
    productsPhotosListTableHeaderProductExternalCode: 'Código Externo',
    productsPhotosListTableHeaderProductName: 'Nome do Produto',

    productPhotosModalEditTitle: 'Editar fotos',
    productPhotosModalDeleteTitle: 'Deletar fotos',
    productPhotosModalAddTitle: 'Adicionar foto',
    productPhotosModalDeleteDescription: 'Selecione as fotos que deseja deletar.',
    productPhotosModalEditDescription: 'Selecione as fotos que deseja editar.',
    productPhotosModalAddDescription: 'Selecione a foto que deseja adicionar.',
    productPhotosModalTableHeaderPicture: 'Foto do Produto',
    productPhotosModalTableHeaderCheckbox: 'Selecione',
    productPhotosModalTableHeaderProductExternalCode: 'Código Externo',
    productPhotosModalTableHeaderProductName: 'Nome do Produto',
    productPhotosModalDeleteAllButton: 'Deletar todas as fotos',
    productPhotosModalAddButton: 'Adicionar foto',
    productPhotosModalDeleteButton: 'Deletar',
    productPhotosModalEditButton: 'Editar',
    productPhotosModalMessage: 'Deseja realmente deletar as fotos selecionadas?',
    productPhotosModalCancel: 'Cancelar',

    productsPhotosFormTitle: 'Cadastro de Fotos',
    productsPhotosFormValidateImage: 'Preencha todos os campos!',
    productsPhotosFormValidateProduct: 'Selecione ao menos um produto.',
    productsPhotosFormLabelProduct: 'Produtos',
    productsPhotosFormEditButton: 'Editar',
    productsPhotosFormSaveButton: 'Salvar',
    productsPhotosFormEmptyPhotos: 'Selecione ao menos uma foto',
    productsPhotosFormDescriptionDelete: 'Deseja excluir imagem do produto?',
    productsPhotosFormSaveSuccessMessage: 'Foto adicionada com sucesso!',
    productsPhotosFormEditSuccessMessage: 'Foto editada com sucesso!',
    productsPhotosFormDeleteSuccessMessage: 'Foto(s) apagada(s) com sucesso!',

    //PRODUCT-DETAILS
    productDetailsTitle: 'Detalhes do produto',
    productDetailsLabelTechnicalInformation: 'Informação técnica.',
    productDetailsLabelApplication: 'Aplicação',
    productDetailsPromotionKit: 'Promoção Kit/Combo',
    productDetailsLabelCode: 'Código',
    productDetailsLabelMasterPacking: 'Emb. master',
    productDetailsLabelMasterUnit: 'Unidade',
    productDetailsLabelBrand: 'Marca',
    productDetailsLabelSection: 'Seção',
    productDetailsLabelSalePacking: 'Emb. venda',
    productDetailsLabelCommission: 'Comissão',
    productDetailsLabelUnitPrice: 'Preço unitário',
    productDetailsLabelPackingPrice: 'Preço da embalagem',
    productDetailsLabelPackingType: 'Embalagem de venda',
    productDetailsLabelSubsidiaryStock: 'Filial de retira',
    productDetailsLabelPacking: 'Embalagem',
    productDetailsLabelTotalAvailableQuantity: 'Estoque geral',
    productDetailsLabelAvailableQuantity: 'Qtd. disponível',
    productDetailsLabelAvailableQuantityProductExpiry: 'Qtd. disponível (Consultar o lote)',
    productDetailsLabelTaxation: 'Valor ST',
    productDetailsLabelIPI: 'Valor IPI',
    productDetailsLabelFCP: 'Valor FCP',
    productDetailsLabelRepasse: 'Valor repasse',
    productDetailsLabelICMSReduction: 'Valor redução ICMS',
    productDetailsLabelPISReduction: 'Valor redução PIS',
    productDetailsLabelCOFINSReduction: 'Valor redução COFINS',
    productDetailsLabelTotalReduction: 'Valor redução total',
    productDetailsLabelBarCode: 'EAN',
    productDetailsLabelNCM: 'NCM',
    productDetailsLabelBarCode2: 'DUN',
    productDetailsLabelStock: 'Estoque',
    productDetailsLabelIsSponsored: 'PATROCINADO',
    productDetailsLabelValuePlusTax: 'Valor + impostos',
    productDetailsLabelValueTax: 'Valor impostos',
    productDetailsLabelProfitability: 'Rentabilidade',
    productDetailsLabelMargin: 'Margem',
    productDetailsLabelMinimumPrice: 'Preço mínimo',
    productDetailsLabelPromotionDetails: 'Detalhes da promoção',
    productDetailsLabelPack: 'Embalagem',
    productDetailsLabelSelectPromotion: 'Selecionar promoção',
    productDetailsLabelPromotion: 'Promoção',
    productDetailsLabelSubsidizedItem: 'Item bonificado',
    productDetailsLabelUnitValue: 'Valor {label}',
    productDetailsLabelPackageValue: 'Valor embalagem (QT: {value})',
    productDetailsLabelQuantity: 'Quantidade',
    productDetailsLabelDiscount: 'Desconto',
    productDetailsLabelProductComplement: 'Complemento',
    productDetailsLabelTotal: 'Total',
    productDetailsLabelTotalWeight: 'Peso total',
    productDetailsLabelTotalPrice: 'Preço Total',
    productDetailsLabelAddToCart: 'Adicionar ao carrinho',
    productDetailsLabelAditItemCart: 'Atualizar produto',
    productDetailsLabelAdd: 'Adicionar',
    productDetailsLabelUpdate: 'Atualizar',
    productDetailsLabelCancel: 'Cancelar',
    productDetailsActivePromotion: 'Promoção ativa',
    productDetailsChangePromotionBar: 'Promoção aplicada, valor min: {price}',
    productDetailsMinimumPrice: 'Preço mínimo com promoção',
    productDetailsMaximumPrice: 'Preço máximo',
    productDetailsMinimumPriceTable: 'Preço mínimo de tabela',
    productDetailsLabelAlternativeProducts: 'Produtos alternativos',
    productDetailsLabelAlternativeProductsEmpty: 'Não possui nenhum produto alternativo cadastrado para esse produto',
    productDetailsLabelProductBatchModalTitle: 'Lotes e validades',
    productDetailsLabelProductBatchModalBatch: 'Lote',
    productDetailsLabelProductBatchModalMaturity: 'Vencimento',
    productDetailsLabelProductBatchModalQuantity: 'Quantidade',
    productDetailsLabelProductBatchModalNoBatch: 'Produto sem lotes disponíveis',
    productDetailsLabelProductBatchModalClose: 'Fechar',
    productDetailsLabelProductStockSubsidiariesModalTitle: 'Estoque por filial',
    productDetailsLabelProductStockSubsidiariesModalNoStock: 'Produto sem estoque disponível',
    productDetailsLabelProductStockSubsidiariesModalQuantity: 'Quantidade',
    productDetailsLabelProductStockSubsidiariesModalClose: 'Fechar',
    productDetailsLabelOriginalNumber: 'Número original',
    productDetailsLabelIndustyCode: 'Código de fábrica',
    productDetailsLabelLastDetails: 'Preço última compra',
    productDetaisLabelPoints: 'Pontos',

    //PROMOTION-MODAL
    promotionModalTitle: 'Promoções disponíveis',
    promotionModalNoPromotions: 'Não há promoções disponíveis para esse produto',
    promotionModalConfirmButton: 'Confirmar',
    promotionModalCancelButton: 'Cancelar',

    //PROMOTION-CARD
    promotionCardAutomaticLabel: 'Automática',
    promotionCardValid: 'Válido até',
    promotionCardActiveQuantity: 'Quant. ativação',
    promotionCardActivePrice: 'Valor ativação',
    promotionCardComission: 'Comissão',
    promotionCardPercentual: 'Percentual',
    promotionCardPromoPrice: ' Valor da promoção',
    promotionCardCartQuantity: 'Quant. carrinho',
    promotionCardCartPrice: 'Valor carrinho',
    PromotionCardNameByProduct: 'Promoção por Produto {externalCode}',
    PromotionCardNameByBrand: 'Promoção por Marca {externalCode}',
    PromotionCardNameBySection: 'Promoção por Seção {externalCode}',
    PromotionCardNameByCategory: 'Promoção por Categoria {externalCode}',
    PromotionCardNameByDepartament: 'Promoção por Departamento {externalCode}',
    PromotionCardNameByProvider: 'Promoção por Fornecedor {externalCode}',
    PromotionCardNameByDefault: 'Promoção - Desc. {discount}%',
    //SHOP-HISTORY
    shopHistoryTitle: 'Histórico de compras',
    shopHistoryTableDate: 'Data',
    shopHistoryTableQuantity: 'Quantidade',
    shopHistoryTableAveragePrice: 'Preço médio',
    shopHistoryTableSalesValue: 'Valor',
    shopHistoryHistoryNotFound: 'Nenhum histórico encontrado',
    //VARIANTS ALERT
    variantsAlertTitle: 'Variante(s) encontrada(s) no carrinho',
    variantsAlertMessage:
      'Seu carrinho apresenta o mesmo produto com a(s) variação(ões) abaixo, clique para editar ou adicione um novo:',
    variantsAlertButtonCancel: 'Cancelar',
    variantsAlertButtonAdd: 'Adicionar novo',
    //ORDER-TYPE-LIST
    orderTypeListTitle: 'Tipos de pedido',
    orderTypeListButtonAdd: 'Novo tipo',
    orderTypeListTableHeaderCode: 'Código',
    orderTypeListTabbleHeaderType: 'Tipo',
    orderTypeListTableHeaderDescription: 'Nome',
    orderTypeListTableHeaderCreatedAt: 'Dt. criação',
    orderTypeListTableHeaderUpdatedAt: 'Dt. atualização',
    //ORDER-TYPE-FORM
    orderTypeFormRegisterTitle: 'Cadastro de tipos de pedido',
    orderTypeFormEditTitle: 'Editar tipo de pedido',
    orderTypeFormLabelExternalCode: 'Código Externo',
    orderTypeFormLabelAuxCode: 'Código adicional',
    orderTypeFormLabelName: 'Nome do tipo de pedido',
    orderTypeFormLabelProduct: 'Produtos',
    orderTypeFormLabelMinimumValue: 'Valor Mínimo',
    orderTypeFormLabelMaximumValue: 'Valor Máximo',
    orderTypeFormLabelSubsdiaries: 'Filiais',
    orderTypeFormLabelSubsdiariesPlaceholder: 'Selecionar filiais...',
    orderTypeFormLabelPaymentPlans: 'Plano de pagamentos',
    orderTypeFormLabelPaymentPlansPlaceholder: 'Selecionar planos de pagamentos...',
    orderTypeFormLabelTeams: 'Times',
    orderTypeFormLabelTeamsPlaceholder: 'Selecionar times...',
    orderTypeFormLabelIsActive: 'Ativo',
    orderTypeFormLabelRequiredBasket: 'Obrigar Pedido Cestos no Pedido de Venda',
    orderTypeFormButtonNew: 'Criar tipo de pedido',
    orderTypeFormButtonEdit: 'Atualizar tipo de pedido',
    orderTypeFormRequiredExternalCode: 'Código externo é obrigatório',
    orderTypeFormRequiredName: 'Nome do tipo de pedido é obrigatório',
    orderTypeFormSuccessCreate: 'Tipo de pedido criado com sucesso',
    orderTypeFormSuccessEdit: 'Tipo de pedido editado com sucesso',
    orderTypeEnumNormal: 'Normal',
    orderTypeEnumCollect: 'Retira',
    orderTypeEnumBonification: 'Bonificação',
    orderTypeEnumDeliveryPreFuture: 'Venda futura',
    orderTypeEnumDeliveryPreOrder: 'Remessa',
    orderTypeEnumBonificationFreeTax: 'Bonificação sem Nota Fiscal',
    orderTypeEnumConsignedOrder: 'Venda consignada',
    orderTypeEnumBudgetERP: 'Orçamento ERP',
    orderTypeEnumAssistedSale: 'Venda assistida',
    orderTypeEnumExchange: 'Troca',
    orderTypeEnumBasket: 'Cesto',
    //PRODUCT-KIT-LIST
    productKitListTitle: 'Produto kit',
    //PRODUCT-KIT-FORM
    productKitFormRegisterTitle: 'Cadastro de produto kit',
    productKitFormEditTitle: 'Editar produto kit',
    productKitFormLabelCode: 'Código',
    productKitFormLabelExternalCode: 'Código ERP',
    productKitFormLabelName: 'Nome',
    productKitFormLabelBarCode: 'Código de barra',
    productKitFormLabelBrand: 'Marca',
    productKitFormRequiredExternalCode: 'Código externo é obrigatório',
    productKitFormRequiredName: 'Nome do produto é obrigatório',
    productKitFormButtonEdit: 'Editar produto',
    productKitFormButtonNew: 'Criar produto',
    // SALES TRACKING
    sidebarMenuItemSalesTracking: 'Acomp. de Vendas',
    salesTrackingTitle: 'Acompanhamento de Vendas',
    salesTrackingLastAtualization: 'Última Atualização:',
    salesTrackingError: 'Ocorreu um erro na sua requisição',
    salesTrackingWithoutData: 'Nenhuma venda para acompanhar',
    // PRODUCTS-LIST
    productsTitle: 'Produtos',
    productsFilterTitle: 'Filtro de produtos',
    productsFilterLabelLocalizationItem: 'Filial',
    productsFilterLabelWithStock: 'Apenas com estoque',
    productsFilterLabelWithoutStock: 'Com/Sem Estoque',
    productsFilterQueryString: 'Pesquisar',
    productsFilterBrand: 'Marca',
    productsFilterSection: 'Seção',
    productsFilterButton: 'Filtros',
    productsFilterCode: 'Código',
    productsFilterBarCode: 'Cod. Barras',
    productsFilterName: 'Nome',
    productsFilterApply: 'Aplicar Filtros',
    productsFilterStock: 'Estoque',
    productsFilterPrice: 'Preço',

    //JUSTIFICATIVAS
    justificationsTitle: 'Justificativas',
    justificationsButtonAdd: 'Nova justificativa',
    justificationsDeleteButton: 'Deletar',

    justificationsListTableHeaderCode: 'Código',
    justificationsListTableHeaderDescription: 'Descrição',
    justificationsListTableHeaderCreatedAt: 'Dt. criação',
    justificationsListTableHeaderUpdatedAt: 'Dt. atualização',

    justificationsFormTitle: 'Cadastro de Justificativas',
    justificationsFormLabelDescription: 'Descrição',
    justificationsFormButtonEdit: 'Editar',
    justificationsFormButtonNew: 'Salvar',
    justificationFormModalDeleteMessage:
      'Atenção: Essa justificativa pode ter sido utilizada, deseja realmente excluí-la?',
    justificationFormModalUpdateMessage:
      'Atenção: Todos as visitas que utilizam essa justificativa serão atualizadas. Deseja realmente atualizar?',
    justificationsFormUpdatedMessage: 'Justificativa atualizada com sucesso!',
    justificationsFormCreatedMessage: 'Justificativa criada com sucesso!',
    justificationsFormDeleteMessage: 'Justificativa excluída com sucesso!',

    justificationsFormMessageRequiredDescription: 'Descrição é obrigatório',

    //Relatórios

    //Avaliações
    ratingsTitle: 'Avaliações',
    ratingsFilterButton: 'Filtros',
    ratingsDownloadCSVButton: 'Download CSV',
    ratingsFilterTitle: 'Filtro de Avaliações',
    ratingsApplyFilterButton: 'Aplicar Filtros',
    ratingsInputVendors: 'Vendedores',
    ratingsLabelId: 'ID',
    ratingsLabelClient: 'Cliente',
    ratingsLabelVendor: 'Vendedor',
    ratingsLabelRating: 'Avaliação',
    ratingsLabelMessage: 'Mensagem',

    //Visita aos clientes
    clientVisitTitle: 'Visita aos clientes',
    clientVisitFilterButton: 'Filtros',
    clientVisitLabelClient: 'Cliente',
    clientVisitLabelVendor: 'Vendedor',
    clientVisitLabelHaveSale: 'Houve venda?',
    clientVisitLabelOrderNumbers: 'Pedidos',
    clientVisitLabelHaveFeedback: 'Houve feedback?',
    clientVisitLabelDateCheckin: 'Dt. Checkin',
    clientVisitLabelDateCheckout: 'Dt. Checkout',
    clientVisitLabelStayTime: 'Duração',
    clientVisitLabelLatitude: 'Latitude',
    clientVisitLabelLongitude: 'Longitude',
    clientVisitLabelCreatedAt: 'Dt. criação',
    clientVisitLabelActions: 'Ações',
    clientVisitDownloadCSVButton: 'Download CSV',
    clientVisitDownloadXlsxButton: 'Download XLSX',

    clientVisitFilterTitle: 'Filtros',

    clientVisitInputOrderNumber: 'Número do pedido',
    clientVisitInputVendors: 'Vendedores',
    clientVisitInputClients: 'Clientes',
    clientVisitInputJustifications: 'Justificativas',
    clientVisitInputHaveFeedback: 'Houve feedback?',
    clientVisitInputHaveSale: 'Houve venda?',
    clientVisitApplyFilterButton: 'Filtrar',

    clientVisitTableRowYes: 'Sim',
    clientVisitTableRowNo: 'Não',
    clientVisitTableRowFeedbacks: 'Visualizar Detalhes',

    clientVisitModalTabFeedback: 'Feedbacks',
    clientVisitModalTabOrders: 'Pedidos',

    clientVisitModalDetailsFeedbackTitle: 'Detalhes da Visita',
    clientVisitModalDetailsFeedbackUser: 'Usuário',
    clientVisitModalDetailsFeedbackClient: 'Cliente',
    clientVisitModalDetailsFeedbackMessage: 'Mensagem do Feedback',
    clientVisitModalDetailsFeedbackCreatedAt: 'Dt. criação',

    clientVisitModalDetailsFeedbackOrderUser: 'Usuário',
    clientVisitModalDetailsFeedbackOrderClient: 'Cliente',
    clientVisitModalDetailsFeedbackOrderNumber: 'Pedido',
    clientVisitModalDetailsFeedbackOrderCreatedAt: 'Dt. criação',

    clientVisitModalDetailsFeedbackEmpty: 'A visita não possui nenhum feedback cadastrado',
    clientVisitModalDetailsOrdersEmpty: 'Sem pedidos cadastrados',
    clientVisitModalDetailsFeedbackClose: 'Fechar',

    // CLIENT CHECKLIST REPORT
    clientChecklistReportTitle: 'Questionários',
    clientChecklistReportDownloadCSVButton: 'Download CSV',
    clientChecklistReportDownloadXLSXButton: 'Download XLSX',
    clientChecklistReportFilterButton: 'Filtros',
    clientChecklistReportFilterStatus: 'Filtrar Ativo/Inativo',
    clientChecklistReportTableHeaderStatus: 'Status',

    clientChecklistReportTableHeaderVendor: 'Cadastrado por',
    clientChecklistReportTableHeaderQuestionaryName: 'Nome do questionário',
    clientChecklistReportTableHeaderCreatedAt: 'Criado em',
    clientChecklistReportTableHeaderUpdatedAt: 'Atualizado em',
    clientChecklistReportTableRowAnswers: 'Respostas do Questionário',

    clientChecklistReportFilterTitle: 'Filtro de Questionários',
    clientChecklistReportFilterVendors: 'Vendedores',
    clientChecklistReportFilterClients: 'Clientes',
    clientChecklistReportFilterApplyButton: 'Filtrar',

    clientChecklistReportModalTitle: 'Detalhes do questionário',
    clientChecklistReportModalQuestionaryName: 'Nome do questionário',
    clientChecklistReportModalQuestionName: 'Pergunta',
    clientChecklistReportModalTypeQuestion: 'Tipo de resposta',
    clientChecklistReportModalPhotosRequired: 'Fotos obrigatórias?',
    clientChecklistReportModalAlternatives: 'Alternativas',
    clientChecklistReportModalRequired: 'Obrigatório?',
    clientChecklistReportModalAnswers: 'Respostas',
    clientChecklistReportModalTableTitle: 'Respostas',
    clientChecklistReportModalClose: 'Fechar',

    clientChecklistReportModalTableHeadUser: 'Usuário',
    clientChecklistReportModalTableHeadClient: 'Cód. Cliente',
    clientChecklistReportModalTableHeadQuestionAnswers: 'Perguntas e Respostas',
    clientChecklistReportModalLabelQuestion: 'Pergunta',
    clientChecklistReportModalLabelResponse: 'Resposta',
    clientChecklistReportModalLabelPhotos: 'Fotos',

    // Promotion Kit Report
    promotionKitReportTitle: 'Relatório de Promoções Kit/Combos',
    promotionKitReportDownloadXSLXButton: 'Download XSLX',

    promotionKitReportTableHeaderOrderNumber: 'Número do pedido',
    promotionKitReportTableHeaderPromotion: 'Promoção',
    promotionKitReportTableHeaderTotalQuantity: 'Qtd. total de itens no kit',
    promotionKitReportTableHeaderClient: 'Cliente',
    promotionKitReportTableHeaderTotalValue: 'Valor total',
    promotionKitReportTableHeaderCreatedAt: 'Criado em',
    promotionKitReportTableHeaderUpdatedAt: 'Atualizado em',

    promotionKitReportFilterTitle: 'Filtro de Kits/Combos',
    promotionKitReportFilterPromotionName: 'Nome/Número da Promoção',
    promotionKitReportFilterClient: 'Cliente',
    promotionKitReportFilterApplyButton: 'Filtrar',

    promotionKitReportModalTitle: 'Detalhes do Kit/Combo',
    promotionKitReportModalTotals: 'Totais',
    promotionKitReportModalCloseButton: 'Fechar',

    commissionRouteReportDownloadXSLXButton: 'Download XSLX',
    commissionRouteReportDownloadCSVButton: 'Download CSV',

    // Relatório de Roteirização
    dailyRouteReportTitle: 'Relatório de Rota Diária',
    dailyRouteReportDownloadXSLXButton: 'Download XSLX',
    dailyRouteReportDownloadCSVButton: 'Download CSV',
    dailyRouteReportFilterSellers: 'Vendedores',

    dailyRouteReportTabSuccess: 'Sucesso',
    dailyRouteReportTabFailed: 'Falha',

    dailyRouteReportTableHeaderOrderNumber: 'Número do pedido',
    dailyRouteReportTableHeaderPromotion: 'Promoção',
    dailyRouteReportTableHeaderTotalQuantity: 'Qtd. total de itens no kit',
    dailyRouteReportTableHeaderClient: 'Cliente',
    dailyRouteReportTableHeaderUser: 'Vendedor',
    dailyRouteReportTableHeaderCheckInCheckOut: 'Check-in/Check-out',
    dailyRouteReportTableHeaderTotalVisits: 'Total de visitas',
    dailyRouteReportTableHeaderRoute: 'Rota',
    dailyRouteReportTableHeaderTotalValue: 'Valor total',
    dailyRouteReportTableHeaderCreatedAt: 'Criado em',
    dailyRouteReportTableHeaderUpdatedAt: 'Atualizado em',
    dailyRouteReportTableHeaderWasOnRoute: 'Estava na rota',
    dailyRouteReportTableHeaderHaveSale: 'Houve venda',
    dailyRouteReportTableHeaderVisitOrder: 'Ordem de visita',
    dailyRouteReportTableHeaderVisitLength: 'Tempo de visita',
    dailyRouteReportTableHeaderJustification: 'Justificativa',

    //Relatorio de Visitas e Vendas de Clientes
    clientVisitAndSalesReportTableHeaderExternalCode: 'Código do Cliente',
    clientVisitAndSalesReportTableHeaderClient: 'Cliente',
    clientVisitAndSalesReportTableHeaderUserExternalCode: 'Código do Vendedor',
    clientVisitAndSalesReportTableHeaderUser: 'Vendedor',
    clientVisitAndSalesReportTableHeaderHasOrderOnSelectedDays: 'Houve pedido',
    clientVisitAndSalesReportTableHeaderOrderNumber: 'Número do Pedido',
    clientVisitAndSalesReportTableHeaderOrderCreatedAt: 'Data do Pedido',
    clientVisitAndSalesReportTableHeaderDaysOfWeek: 'Dias da Semana',

    // Controle de Notificações
    persistentNotificationsTitle: 'Controle de Notificações',
    persistentNotificationsFilterButton: 'Filtros',
    persistentNotificationsListItemAvatar: 'Avatar',
    persistentNotificationsListItemName: 'Nome',
    persistentNotificationsListItemEmail: 'Email',
    persistentNotificationsListItemTotalNotifications: 'Total de Notificações',
    persistentNotificationsListItemTotalActions: 'Ações',
    persistentNotificationsDownloadCSVButton: 'Download CSV',

    persistentNotificationsFilterTitle: 'Filtros',
    persistentNotificationsFilterVendorInput: 'Vendedores',
    persistentNotificationsFilterApplyFilters: 'Aplicar Filtros',

    persistentNotificationsModalDetailsTitle: 'Notificações',
    persistentNotificationsModalListItemTitle: 'Título',
    persistentNotificationsModalListItemShortMessage: 'Mensagem curta',
    persistentNotificationsModalListItemMessage: 'Mensagem',
    persistentNotificationsModalListItemCreatedAt: 'Data de criação',
    persistentNotificationsModalListItemButton: 'Visualizar Notificações',
    persistentNotificationsModalEmpty: 'Nenhuma notificação cadastrada',
    persistentNotificationsModalClose: 'Fechar',

    //Product Bonification
    productBonificationListTitle: 'Controle de produtos bonificados',
    productBonificationFilterButton: 'Filtros',
    productBonificationAddButton: 'Novo controle de bonificação',

    productBonificationFormTitle: 'Cadastro de controle de produtos bonificados',

    productBonificationListRestriction: 'Nome da restrição',
    productBonificationListCreatedAt: 'Dt. criação',
    productBonificationListUpdatedAt: 'Dt. atualização',

    productBonificationUpdatedSuccess: 'Controle atualizado com sucesso!',
    productBonificationCreatedSuccess: 'Controle criado com sucesso!',

    productBonificationExcludeDeleteMessage:
      'Atenção: Esse controle pode ter sido utilizado, deseja realmente excluí-lo?',
    productBonificationExcludeSuccess: 'Controle excluído com sucesso!',

    //Focus supplier

    focusSupplierTitle: 'Fornecedor foco',
    focusSupplierAddButton: 'Novo fornecedor foco',

    focusSupplierListName: 'Fornecedor foco',
    focusSupplierListCreatedAt: 'Dt. criação',
    focusSupplierListUpdatedAt: 'Dt. atualização',

    focusSupplierModalTitle: 'Detalhes do fornecedor foco',

    focusSupplierExcludeDeleteMessage: 'Atenção: Esse foco pode ter sido utilizado, deseja realmente excluí-lo?',
    focusSupplierExcludeSuccess: 'Foco excluído com sucesso!',

    focusSupplierFormTitle: 'Cadastro de fornecedor foco',

    focusSupplierUpdatedSuccess: 'Fornecedor foco atualizado com sucesso!',
    focusSupplierCreatedSuccess: 'Fornecedor foco criado com sucesso!',
    focusSupplierProviderAlreadyExists: 'Fornecedor já cadastrado como foco',

    //Daily Route
    dailyRouteListTitle: 'Rota Diária',
    dailyRouteListButtonAdd: 'Nova rota',
    dailyRouteListTableHeaderBeginDate: 'Dt. início',
    dailyRouteListTableHeaderUserExternalCode: 'Código do usuário',
    dailyRouteListTableHeaderUserName: 'Nome do usuário',
    dailyRouteListTableHeaderAddress: 'Endereço',
    dailyRouteListTableHeaderCreatedAt: 'Dt. criação',
    dailyRouteListTableHeaderUpdatedAt: 'Dt. atualização',

    dailyRouteFilterSellers: 'Vendedores',
    dailyRouterFilterApplyFilters: 'Aplicar Filtros',

    dailyRouteFormTitle: 'Cadastro de rota diária',
    dailyRouteFormLabelBeginDate: 'Data de início',
    dailyRouteFormLabelUser: 'Usuário',

    dailyRouteFormValidationBeginDateRequired: 'Data de início é obrigatório',
    dailyRouteFormValidationUserRequired: 'Usuário é obrigatório',
    dailyRouteFormValidationPositionRequired: 'Posição é obrigatória, busque um endereço para definir a posição',
    dailyRouteFormValidationStateRequired: 'Estado é obrigatório quando a opção de selecionar cidades está ativada',
    dailyRouteFormValidationExclusiveCitiesRequired:
      'As cidades são obrigatórias quando a opção de selecionar cidades para o usuário percorrer durante o dia está ativada',

    dailyRouteFormValidationVisitCyclesRequired: 'É necessário adicionar pelo menos um ciclo de visita',

    dailyRouteFormUpdatedSuccess: 'Rota atualizada com sucesso!',
    dailyRouteFormCreatedSuccess: 'Rota criada com sucesso!',
    dailyRouteFormExcludeSuccess: 'Rota excluída com sucesso!',
    dailyRouteFormErrorAlreadyExists: 'Já existe uma rota para o usuário selecionado na data informada.',
    dailyRouteFormExcludeDeleteMessage: 'Atenção: Essa rota pode ter sido utilizada, deseja realmente excluí-la?',

    // Product Technical Data
    productTechnicalDataListTitle: 'Dados Técnicos do Produto',
    productTechnicalDataListButtonAdd: 'Novo dado técnico de um produto',
    productTechnicalDataListButtonBatchUpload: 'Enviar zip em massa',

    productTechnicalModalAddTitle: 'Enviar zip em massa',
    productTechnicalModalAddDescription: 'Selecione o arquivo zip para enviar',
    productTechnicalModalAddButton: 'Enviar',
    productTechnicalModalCancel: 'Cancelar',

    productTechnicalDataFormLabelProductExternalCode: 'Código do Produto',
    productTechnicalDataFormLabelProductName: 'Nome do Produto',
    productTechnicalDataFormLabelProductTechnicalSheetUrl: 'URL da Ficha Técnica',
    productTechnicalDataFormDownloadButton: 'Download',

    productTechnicalDataFormTitle: 'Dados Técnicos do Produto',
    productTechnicalDataFormLabelProduct: 'Produto',
    productTechnicalDataFormValidateProduct: 'Produto é obrigatório',
    productTechnicalDataFormValidateImage: 'Imagem é obrigatória',
    productTechnicalDataFormEditButton: 'Editar',
    productTechnicalDataFormSaveButton: 'Salvar',

    productTechnicalDataFormEditSuccessMessage: 'Dados técnicos do produto editado com sucesso!',
    productTechnicalDataFormSaveSuccessMessage: 'Dados técnicos do produto salvo com sucesso!',
    productTechnicalDataFormDeleteButton: 'Deletar',
    productTechnicalDataFormDeleteSuccessMessage: 'Dados técnicos do produto deletado com sucesso!',
    productTechnicalDataFormDescriptionDelete:
      'Atenção: Esses dados técnicos podem ter sido utilizados, deseja realmente excluí-los?',

    // Auditorias

    // Auditoria de Usuários
    userAuditTitle: 'Auditoria de Usuários',
    userAuditListItemUserName: 'Usuário',
    userAuditListItemEmail: 'Email',
    userAuditListItemExternalCode: 'Código do Usuário',
    userAuditListItemCreatedAt: 'Dt. criação',
    userAuditListItemUpdatedAt: 'Dt. atualização',
    userAuditListItemAction: 'Tipo de ação',

    //accountBalance
    accountBalanceDetailsLabel: 'Saldo do vendedor',
    accountBalanceDetailsLabelDiscount: 'Valor descontado',
    orderCreateCheckoutInitialDateLabel: 'Data inicial',
    orderCreateCheckoutEndDateLabel: 'Data final',
    accountBalanceMenuLabel: 'Saldo CC',
    accountBalanceMenuStatementLabel: 'Extrato CC',
    accountBalanceMenuSectionTitle: 'Conta Corrente',
    accountBalancePreviousBalanceLabel: 'Saldo anterior',
    accountBalanceEmptyMessage: 'Nenhum lançamento encontrado para o período selecionado.',
    accountBalanceOrderNumberLabel: 'Nº pedido',
    accountBalanceSearchButtonLabel: 'Buscar',
    accountBalanceLoadMoreLabel: 'Carregar mais',
    accountBalanceLoadingMoreLabel: 'Carregando...',

    //Roteirização
    vendorRouteListTitle: 'Roteirização',
    vendorRouteListButtonAdd: 'Nova roteirização',
    vendorRouteListTableHeaderBeginDate: 'Dt. início',
    vendorRouteListTableHeaderUserExternalCode: 'Código do usuário',
    vendorRouteListTableHeaderUserName: 'Nome do usuário',
    vendorRouteListTableHeaderAddress: 'Endereço',
    vendorRouteListTableHeaderCreatedAt: 'Dt. criação',
    vendorRouteListTableHeaderUpdatedAt: 'Dt. atualização',

    vendorRouteFormTitle: 'Cadastro de roteirização',
    vendorRouteFormLabelBeginDate: 'Data de início',
    vendorRouteFormLabelUser: 'Usuário',

    vendorRouteFormValidationBeginDateRequired: 'Data de início é obrigatório',
    vendorRouteFormValidationUserRequired: 'Usuário é obrigatório',
    vendorRouteFormValidationPositionRequired: 'Posição é obrigatória',

    //INDICATORS
    indicatorsTitle: 'Indicadores',
    indicatorsLoadingMessage: 'Carregando indicadores...',
    indicatorsEmptyMessage: 'Nenhum indicador disponível no momento.',
    indicatorsErrorMessage: 'Erro ao carregar indicadores. Tente novamente.',
    indicatorsGoalLabel: 'Meta',
    indicatorsAccomplishedLabel: 'Realizado',
    indicatorsProjectionLabel: 'Projeção',
    indicatorsDetailsLabel: 'Detalhes',
    indicatorsRecalculatedDailyGoalLabel: 'Meta diária recalculada',
    indicatorsSoldTodayLabel: 'Vendido hoje',
    indicatorsSalesTitle: 'Vendas',
    indicatorsSalesDescription: 'Acompanhe o progresso de vendas em relação à meta estabelecida',
    indicatorsPositivationTitle: 'Positivação de cliente',
    indicatorsPositivationDescription: 'Quantidade de clientes únicos atendidos no período',
    indicatorsPercentageProfitTitle: 'Lucro %',
    indicatorsPercentageProfitDescription: 'Percentual de lucro sobre as vendas realizadas',
    indicatorsValueProfitTitle: 'Lucro R$',
    indicatorsValueProfitDescription: 'Valor total de lucro em reais obtido no período',
    indicatorsPositiveMixTitle: 'Mix Positivado',
    indicatorsPositiveMixDescription: 'Quantidade de produtos positivados no período',
    sidebarMenuItemCommissionReport: 'Relatório de comissão por liquidez - Sintético',
    commissionReportBeginDate: 'Data de início',
    commissionReportEndDate: 'Data de fim',
    commissionReportNetValue: 'Comissão bruta',
    commissionReportPercentual: 'Percentual de comissão',
    commissionReportBilledOrders: 'Quantidade de pedidos',
    commissionReportCommissionValue: 'Valor da comissão líquida',
    commissionReportTicket: 'Vales',
    commissionReportRefundValue: 'Devoluções',
    commissionReportDate: 'Período',
    commissionReportTotalValue: 'Valor recebido',
    commissionReportTotalValueMobile: 'Vendas',
    commissionReportAction: 'Ação',
    commissionReportModalTitle: 'Detalhes',
    commissionReportButton: 'Detalhes',
    commissionReportDetails: 'Detalhes do dia',
    commissionReportChatTitle: ' Histórico de comissões',
    commissionReportIconDetails: 'Detalhes do mês',
    commissionReportCurrent: 'Comissão líquida atual',
    commissionReportBillingPeriod: 'Período de faturamento',
    commissionReportPaymentPeriod: 'Período de pagamento',
    commissionReportPaymentCommissionDate: ' Data do pagamento da comissão',
    clientPositionReportIssueDate: 'Data de emissão',
    clientPositionReportDueDate: 'Data de vencimento',
    clientPositionReportInvoiceNumber: 'Número da nota',
    clientPositionReportTradeName: 'Nome fantasia',
    clientPositionReportCompanyName: 'Razão social',
    clientPositionReportPaymentMethod: 'Forma de pagamento',
    clientPositionReportDaysLate: 'Dias atrasados',
    clientPositionReportBankSlipLine: 'Código de barras',
    clientPositionReportValue: 'Valor',

    //Routing
    routingListTitle: 'Roteirização',
    routingListPlanningButton: 'Planejamento',
    routingListTabManual: 'Rotas manuais',
    routingListTabAi: 'Rotas geradas por IA',
    routingListTableHeaderSellerCode: 'Cód. Vendedor',
    routingListTableHeaderName: 'Nome',
    routingListTableHeaderVisitsPerDay: 'Visitas por dia',
    routingListTableHeaderRouteStartDate: 'Início da rota',
    routingListTableHeaderCreatedAt: 'Criado em',
    routingListTableHeaderUpdatedAt: 'Atualizado em',
    routingListActionEdit: 'Editar',
    routingListActionDelete: 'Excluir',
    routingSuccessSave: 'Rota salva com sucesso',
    routingSuccessDelete: 'Rota excluída com sucesso',
    routingConsultationTitle: 'Roteirização - Consulta de Rotas',
    routingConsultationBreadcrumb: 'Roteirização - Consulta',
    routingSearchClient: 'Buscar cliente',
    routingSearchClientPlaceholder: 'Código ou nome do cliente',
    routingVendorLabel: 'Vendedor: ',
    routingWeekLabel: 'Semana',
    routingMonthLabel: 'Mês',
    routingYearLabel: 'Ano',
    routingValidationWeekPrefix: 'Semana',
    routingValidationMinClientsError: '— tem menos de 4 clientes',
    routingValidationHolidayWarning: '— é feriado nacional. Clientes neste dia serão visitados normalmente.',
    routingDaySunday: 'Domingo',
    routingDayMonday: 'Segunda',
    routingDayTuesday: 'Terça',
    routingDayWednesday: 'Quarta',
    routingDayThursday: 'Quinta',
    routingDayFriday: 'Sexta',
    routingDaySaturday: 'Sábado',
    routingWeekly: 'Semanal',
    routingBiweekly: '15 em 15 dias',
    routingMonthly: 'Mensal',
    routingDaily: 'Diário - Avulso',
    routingBiweeklyOption: 'Quinzenal',
    routingClients: 'Clientes',
    routingDragToAdd: 'Arraste para adicionar na rota',
    routingSearchByName: 'Pesquisar por nome...',
    routingNoClientAvailable: 'Nenhum cliente disponível.',
    routingNeighborhood: 'Bairro',
    routingNoNeighborhoodsForCity: 'Nenhum bairro cadastrado para essa cidade',
    routingSelectCityFirst: 'Selecione uma cidade',
    routingIncludeInRoute: 'Incluir na Rota',
    routingClientRouted: 'Cliente roteirizado',
    routingClientNotRouted: 'Cliente não roteirizado',
    routingWeekOfMonth: 'Semana do mês',
    routingNoPeriodicity: 'Sem periodicidade',
    routingEditRoute: 'Editar rota',
    routingDropHere: 'Solte aqui',
    routingHoliday: 'Feriado',
    routingPlanningTitle: 'Roteirização - Planejamento de Rotas',
    routingSelectVendor: 'Selecionar Vendedor',
    routingState: 'UF',
    routingCity: 'Cidade',
    routingLegend: 'Legenda',
    routingAllClients: 'Todos',
    routingRoutedClients: 'Clientes roteirizados',
    routingUnroutedClients: 'Clientes não roteirizados',
    routingSaveRoute: 'Salvar Rota',
    routingDayOfWeek: 'Dia da semana',
    routingPeriodicity: 'Periodicidade',
    routingVisitOrder: 'Ordem de Visita',
    routingBiweeklyWithOption: 'Quinzenal (15 em 15 dias)',
    routingSelectVendorRequired: 'Vendedor é obrigatório',
    routingAiSettingsTitle: 'Configurações de Roteirização IA',
    routingAiSettingsButton: 'Configurações de roteirização IA',
    routingAiRecommendButton: 'Recomendar Roteirização por IA',
    routingAiRecommendDisabledTooltip:
      'Para habilitar a recomendação por IA, salve uma configuração de roteirização IA no ícone de engrenagem ao lado, informando o vendedor e o ponto de partida.',
    routingAiStartingPoint: 'Ponto de partida',
    routingAiSelectStartingPoint: 'Selecionar ponto de partida',
    routingAiSelectStartingPointHint: 'Clique no mapa ou busque um endereço para definir o ponto de partida.',
    routingAiSelectedAddress: 'Endereço selecionado',
    routingAiNoStartingPointSelected: 'Nenhum ponto selecionado',
    routingAiMinVisitsPerDay: 'Quantidade mínima de visitas por dia',
    routingAiMaxVisitsPerDay: 'Quantidade máxima de visitas por dia',
    routingAiNextDay: 'No dia seguinte',
    routingAiNextDayReturnToStart: 'Voltar para o ponto de partida (Filial)',
    routingAiNextDayFollowLastPoint: 'Seguir do último ponto visitado',
    routingAiSaveSettings: 'Salvar Configurações',
    routingAiSettingsSaveSuccess: 'Configurações de roteirização por IA salvas com sucesso',
    routingAiJobQueued: 'Roteirização por IA enviada para a fila. Avisaremos quando ficar pronta.',
    routingAiJobCompleted: 'Sua roteirização por IA está pronta!',
    routingAiJobFailed: 'Não foi possível concluir a roteirização por IA.',
    routingAiJobWidgetTitle: 'Roteirização por IA',
    routingAiJobWidgetOpen: 'Abrir status da roteirização por IA',
    routingAiJobWidgetClose: 'Fechar',
    routingAiJobStatusQueued: 'Na fila',
    routingAiJobStatusQueuedHint: 'Sua solicitação está aguardando na fila de processamento.',
    routingAiJobStatusQueuePosition: 'Posição na fila: {position}',
    routingAiJobStatusProcessing: 'Processando',
    routingAiJobStatusProcessingHint: 'A IA está montando as melhores rotas. Isso pode levar alguns minutos.',
    routingAiJobStatusCompleted: 'Concluída',
    routingAiJobStatusCompletedHint: 'Clique aqui para ver as rotas geradas.',
    routingAiJobStatusFailed: 'Falhou',
    routingAiJobStatusFailedHint: 'Ocorreu um erro no processamento. Tente gerar novamente.',
    routingAiJobDismiss: 'Limpar',
    routingAiJobStopPolling: 'Parar consultas',
    routingAiJobResumePolling: 'Retomar',
    routingAiJobPollingStopped: 'Consultas pausadas',
    routingAiJobLastChecked: 'Última verificação às {time} · atualiza a cada minuto',
    routingAiJobWaitingFirstCheck: 'Verificando a cada minuto',
    routingDeleteVendorConfirmation:
      'Deseja realmente excluir o vendedor {name}? Esta ação removerá permanentemente o registro.',

    // Relatório de Clientes Roteirizados
    routedClientsReportTableHeaderUserExternalCode: 'Código',
    routedClientsReportTableHeaderUserName: 'Vendedor',
    routedClientsReportTableHeaderWallet: 'Carteira',
    routedClientsReportTableHeaderPositivatedClients: 'Clientes positivados',
    routedClientsReportTableHeaderRoutedClients: 'Roteirizados',
    routedClientsReportTableHeaderRoutedClientsOnFilter: 'Roteirizados por Período',
    routedClientsReportTableHeaderRoutedClientsPct: '% Roteirizados',
    routedClientsReportTableHeaderUnroutedClients: 'Não Roteirizados',
    routedClientsReportTableHeaderUnroutedClientsPct: '% Não Roteirizados',
    routedClientsReportTableHeaderVisitedOnRoute: 'Visit. na Rota',
    routedClientsReportTableHeaderVisitedOnRoutePct: '% Visit. na Rota',
    routedClientsReportTableHeaderVisitedOffRoute: 'Visit. Fora da Rota',
    routedClientsReportTableHeaderVisitedOffRoutePct: '% Visit. Fora da Rota',
    routedClientsReportTableHeaderNotVisitedFromRoute: 'Não Visit. da Rota',
    routedClientsReportTableHeaderNotVisitedFromRoutePct: '% Não Visitados',
    routedClientsReportTableHeaderRouteCompliancePct: '% Cumprimento de Rota',
    routedClientsReportTableHeaderTotalOrdersOnRoute: 'Total de Pedidos na Rota',
    routedClientsReportTableHeaderSalesWithRemoteVisitPct: 'Total de Pedidos Fora da Rota',
    routedClientsReportTableHeaderTotalOrders: 'Total de Pedidos',
    routedClientsReportTableHeaderEffectivenessPct: '% Eficácia',
    routedClientsReportTableHeaderPenetrationPct: '% Penetração',
    routedClientsReportTableHeaderAlert: 'Alerta',
    routedClientsReportDownloadCSVButton: 'Download CSV',

    // ProductWithoutPictureReport
    sidebarMenuItemProductWithoutPictureReport: 'Produtos Sem Foto',
    productWithoutPictureReportFilterQueryText: 'Buscar por nome ou código',
    productWithoutPictureReportFilterHasPhotoLabel: 'Situação das fotos',
    productWithoutPictureReportFilterHasPhotoFalse: 'Sem foto',
    productWithoutPictureReportFilterHasPhotoTrue: 'Com foto',
    productWithoutPictureReportTableHeaderExternalCode: 'Código',
    productWithoutPictureReportTableHeaderName: 'Nome',
    productWithoutPictureReportTableHeaderBrand: 'Marca',
    productWithoutPictureReportDownloadCSVButton: 'Download CSV',

    // Dynamic Dashboard
    dynamicDashboardFilterSubsidiaries: 'Filiais',
    dynamicDashboardFilterApplyFilters: 'Aplicar Filtros'
  }
};

export default PORTUGUESE;
